import {
  CheckDirectIndirectResponse,
  getPayLessOnAnnualTextData,
  InstandaData,
  InsuredItems,
  NotifyData,
  packageData,
  PopupData,
  QuestionsServiceTypes,
  ReturnBackToCustomerTaskData,
} from '@ahoy/types';
import { Events } from '../events/app-events';
import { requires } from '../mixins/dependency';
import { Question, QuestionCustomList } from '@ahoy/model/dist/question';
import { QuestionsModel } from '../model/questions';
import { AffiliateService } from '@ahoy/model';
import { eventBus } from '../utils/event-bus';
import { ApiService } from './api-service';
import { BaseService } from './base-service';
import { PopupService } from './popup-service';
import { debounce } from '@ahoy/ui/debounce';
import { WebSectionTrackingData } from '@ahoy/types';
import { DateValue } from '@ahoy/model/dist';
import { t, setUploadLinkApplicationIdProvider, setIsRenewalProvider, substituteUploadLinks } from '@APP/utils/locale';
import { GtmService } from '@APP/services/gtm-service';
import { LogoutOrigin } from './user-service';
import { State } from '@ahoy/types';
import { BillingTerm, insurance_package, PackageData, PaymentMethod, Premium } from '@FLAVOR/../../common/types/billing';
import { ToastData } from '@APP/views/components/lh-toast';
import { chatForDropdown, headphonesForDropdown, phoneForDropdown, PromotionToastIcon, WelcomeToastIcon } from '@APP/views/icons/icons';
import { RateValidationResult, UserType } from '@ahoy/model/dist/types';
import { getStateFullName } from '@ahoy/model/dist/utils/states';
import { BooleanValue } from '@ahoy/model/dist/utils/boolean';
import {StringManipulation} from '@ahoy/model/dist/utils/stringManuplation';
import { getQueryParam } from '@ahoy/aquarium/dist/utils/getQueryParam';
import { insuracePackageFromPackageData } from '@APP/utils/insurance-objects';
import { html, TemplateResult } from 'lit';
import { priceFormat } from '@ahoy/model/dist/utils/priceFormat';
import { defer } from '@APP/utils/async-store';
import { unsafeHTML } from 'lit/directives/unsafe-html';
import { dropdownOption } from '@APP/views/components/lh-dropdown';
import { getV1States } from '@ahoy/model/dist/utils/states';
import { MailService } from './mail-service';
import { TechnicalDataType } from '@APP/views/popups/popup-manager';
import { st } from '@ahoy/model/dist/utils/locale';


declare var $zoho: any;
type checkIfValidResponse = {value: boolean; msg: string; errorType?: string, technicalData?: TechnicalDataType};

type Deps = {
  apiService: ApiService;
  popupService: PopupService;
  gtmService: GtmService;
  mailService: MailService;
};

export const dropdownOptions: dropdownOption[] = [
  {
    id: 'callAnAgent',
    icon: headphonesForDropdown,
    text: 'Call an agent',
    onclick: () => {
      eventBus().emit(Events.Type.LogPopupButtonClick, {
        action: 'Call an agent button clicked',
      });
      eventBus().emit(Events.Type.CallAnAgentRequest);
    },
  },
  {
    id: 'getACallBack',
    icon: phoneForDropdown,
    text: 'Get a call back',
    onclick: () => {
      eventBus().emit(Events.Type.LogPopupButtonClick, {
        action: 'Get a call back button clicked',
      });
      eventBus().emit(Events.Type.ReturnBackToCustomerTask, { popupComponentName: 'Packages' });
    },
  },
  {
    id: 'startChat',
    icon: chatForDropdown,
    text: 'Chat with us',
    onclick: () => {
      eventBus().emit(Events.Type.LogPopupButtonClick, {
        action: 'Start chat button clicked',
      });
      $zoho.salesiq.chat.start();
    },
  },
];

const errorCodesMap: QuestionsServiceTypes.ErrorCodesForTaskData[] = [
  {
    popupComponentName: 'non-eligible-popup-add-boat',
    errorCodeText: 'askToAddBoat',
  },
];
@requires(ApiService.serviceName, PopupService.serviceName, GtmService.serviceName, MailService.serviceName)
export class QuestionsService extends BaseService<Deps> {
  static serviceName: string = 'questionsService';

  
  public model = new QuestionsModel();
  public affiliateService?: AffiliateService;
  public mainQuestionnaireId?: string;
  public questionnaireId: string | undefined;
  public isFromCCpayment: boolean = false;
  public imagePreviewMode: boolean = false;
  
  // if these error codes occur then we will not check the new yacht program rules and just show the error
  private noNewYachtProgramErrorCodes = ['UW_Error_45', 'UW_Error_48', 'UW_Error_49','UW_Error_47','UW_Error_50', 'UW_Error_53','UW_Error_54','UW_Error_55','UW_Error_37','UW_Error_56','Underwriting_Approvals_Error'];

  // UW error codes whose popup should hide the "Get Assistance" button (only the next/OK button is shown)
  private noGetAssistanceBtnErrorCodes = [
    'UW_Error_1', 'UW_Error_2', 'UW_Error_3', 'UW_Error_4', 'UW_Error_5',
    'UW_Error_6', 'UW_Error_7', 'UW_Error_8', 'UW_Error_9', 'UW_Error_10',
    'UW_Error_11', 'UW_Error_12', 'UW_Error_13', 'UW_Error_14', 'UW_Error_15',
    'UW_Error_16', 'UW_Error_17', 'UW_Error_18', 'UW_Error_19',
    'UW_Error_21', 'UW_Error_22',
    'UW_Error_36', 'UW_Error_37', 'UW_Error_38', 'UW_Error_39', 'UW_Error_40',
    'UW_Error_41', 'UW_Error_42', 'UW_Error_43', 'UW_Error_44', 'UW_Error_45',
    'UW_Error_46','UW_Error_47',
    'UW_Error_47', 'UW_Error_48', 'UW_Error_49', 'UW_Error_50',
    'UW_Error_53', 'UW_Error_54', 'UW_Error_55', 'UW_Error_56', 'UW_Error_57',
  ];
  private paymentLinkMode = false;
  private memoryMode: boolean = false;
  private patchQueue = new Map<string, Question>();
  private TotalPremium: Premium = { 'annual-amount': 0, 'monthly-amount': 0 };
  private MTAPremium = 0;
  private RenewalMTAPremium = { annual: 0, monthly: 0 };
  private isLoggedIn: boolean = false;
  private updated: boolean = false;
  private ownerZipIsCoastal: boolean = false;
  private garageZipIsCoastal: boolean = false;
  private ownerZipIsCoastalChecked: boolean = false;
  private garageZipIsCoastalChecked: boolean = false;
  private ownerAddressAutocompleteUpdated: boolean = false;
  private garageAddressAutocompleteUpdated: boolean = false;
  private ownerAddressAutocompleteChecked: boolean = false;
  private garageAddressAutocompleteChecked: boolean = false;
  private ownerAddressAutocompleteValid: boolean = false;
  private garageAddressAutocompleteValid: boolean = false;
  private violationError?: boolean = undefined;
  private validDriver: boolean = false;
  private validDriverChecked: boolean = false;
  // DISABLED with the past-boat trigger — kept for reference.
  // Guards the claims-summary refresh to run once per session (resets on page load / new instance).
  // private claimsSummaryFetched: boolean = false;
  private userType: UserType = 'customer';
  private allowedToSellAgent: State[] = [];
  private allowedToSellAgency: State[] = [];
  private stormStates: State[] = [];
  private listQuestionComponentsToQuestionIdsMap: Map<string, string[]> = new Map<string, string[]>();
  private dataUpdatedForMta: boolean = false;
  private MTARatesNotEqual: boolean = false;
  private updatedPaymentMethodType: 'Bank Account' | 'Credit Card' | '' = '';
  private chargeProcessingFee: boolean = true;
  private disputedIssuesFound: boolean | null = null;
  private disputeIssuesData: (RateValidationResult & { allowed_purchase_date: string; } | null) = null;
  private not_allowed_to_use_Agents_Portal:boolean = false;
   
  constructor() {
    super();
    this.sendPatchQueue = debounce(this.sendPatchQueue, 1000);
    // Register the applicationId source for the lighthouse t() wrapper so any
    // UW-error message carrying a $_UPLOAD_SURVEY / $_UPLOAD_BOS marker can
    // build the customer_document_upload deep link on the fly. Closure is
    // evaluated each t() call — safe to register before the model is loaded;
    // it'll just return undefined until then (the marker is silently dropped).
    setUploadLinkApplicationIdProvider(() => this.model?.getQuestionnaireId() || undefined);
    // Renewal gate for the "customer has already provided <X>" note in
    // substituteUploadLinks. checkIfRenewal() is safe pre-model-load (returns
    // false until Is_Renewal is hydrated).
    setIsRenewalProvider(() => this.checkIfRenewal());
    eventBus().on<string>(Events.Type.OcrUserResetOcrValues, () => {
      this.handleResetOcrInput();
    }),
    eventBus().on<Question>(Events.Type.QuestionUpdate, (q) => {
      // this is used to prevent sending patches when the memory mode is on, except for the last_error question
      if (!this.memoryMode || (this.memoryMode && q.questionId == 'last_error')) {
        this.addToPatchQueue(q);
        this.sendPatchQueue();
      }
      this.onQuestionUpdate(q);
    });
    eventBus().on<any>(Events.Type.SetStormStates, ({ stormStates }) => { this.setStormStates(stormStates); });
    eventBus().on<any>(Events.Type.ExitPopupClose, () => { this.logExitPopupClosed(); });
    eventBus().on<any>(Events.Type.ShowPopupOnEvent, async(popupData: PopupData) => {
      await this.deps.popupService.showPopup(popupData.popupName, popupData.message, t(popupData.buttonText), popupData.popupClassName);
    }),
    eventBus().on(Events.Type.ImagePreviewModeChange, ({ value }) => {
      this.imagePreviewMode = value;
    }),
    eventBus().on<any>(Events.Type.ShowPopup, (popupData: PopupData) => {
      if (!popupData) return;

      /** Logout without popup for internal or external agents  */
      const isInternalAgent = this.isAgent();
      const isExternalAgent = this.isExternalAgent();
      if (isInternalAgent || isExternalAgent) {
        /** On Logout-button click: Internal and external agents return to portal without exit-popup displayed */
        if (popupData?.buttonText === 'Logout') {
          eventBus().emit(Events.Type.Logout, { reload: true, origin: 'Logout button (agents)' });
        } else {
          /** On Logo click: the exit popup is displayed for agents */
          this.showExitPopup(popupData);
        }
      } else {
        /** For customers exit-popup is always displayed */
        this.showExitPopup(popupData);
      }
    });
    eventBus().on<any>(Events.Type.ReturnBackToCustomerTask, (data: ReturnBackToCustomerTaskData) => {
      const { popupComponentName, showConfiramtionMsgInPopup } = data;
      this.returnBackToCustomerTask(popupComponentName, showConfiramtionMsgInPopup);
    });
    eventBus().on<Question>(Events.Type.LoginSuccess, () => {
      this.isLoggedIn = true;
      this.flushPatchQueue();
    });
    eventBus().on<Question>(Events.Type.Refresh, () => {
      this.isLoggedIn = true;
      this.flushPatchQueue();
    });
    /** Send tracking data to Hubspot */
    eventBus().on(Events.Type.SaveWebSectionTracking, (data) => {
      const { operation, section } = data;
      const welcomeSection = ['S_Welcome'].includes(section);
      const skipHubdataTracking = ['Arrival', 'load', 'send-otp', 'send-code', 'welcome-next', 'welcome-update', 'welcome-error', 'about-popup', 'change-to-signup', 'change-to-login'].includes(operation);
      if (skipHubdataTracking && welcomeSection) return;
      this.saveWebSectionTracking(data);
    });
    /** Send tracking notification */
    eventBus().on(Events.Type.NotifyTracking, (data) => { this.notifyTracking(data); });

    eventBus().on(Events.Type.NavigatingOutOfNewLp, async() => {
      const name: string = this.model.getQuestionById('owner_name')?.value as string;
      const email: string = this.model.getQuestionById('email')?.value as string;
      await this.createLead(name, email);
    });

    eventBus().on(Events.Type.StartInsuranceToday, () => this.startInsuranceToday(true));
  }

  public setDisputeIssuesFound(value: boolean) {
    this.disputedIssuesFound = value;
  }

  public getDisputeIssuesFound() {
    return this.disputedIssuesFound;
  }

  public setDisputeIssuesData(value: (RateValidationResult & { allowed_purchase_date: string; } | null)) {
    this.disputeIssuesData = value;
  }

  public getDisputeIssuesData() {
    return this.disputeIssuesData;
  }

  public setPaymentLinkMode(value: boolean) {
    this.paymentLinkMode = value;
  }

  public getPaymentLinkMode() {
    return this.paymentLinkMode;
  }

  private async checkIfMaxPolicyLimitReached({ calledAsStandAlone = false, qId = '' } = {}) {
    if (calledAsStandAlone) {
      this.deps.apiService.lock();
      await this.flushPatchQueue();
    }
    let result = null;
    try {
      result = (await this.deps.apiService.http('/insure/policy-limit', { qId })).data;
      return { success: true, value: result.isMaxPolicyLimitReached };
    } catch (err) {
      const data: WebSectionTrackingData = {
        section: 'S_Billing',
        next_section: '',
        operation: 'Error',
        errorMessage: JSON.stringify(err, null, ' '),
      };
      eventBus().emit(Events.Type.SaveWebSectionTracking, data);
      return { success: false, value: null };
    } finally {
      if (calledAsStandAlone) this.deps.apiService.unlock();
    }
  }

  // this sends the renewal quote
  public async handleSendRenewalQuote() {
    const functionName = 'handleSendRenewalQuote';
    const { apiService, mailService } = this.deps;
    const checkIfRenewalMail = () => {
      const isRenewal = this.checkIfRenewal();
      const { Renewal_Status: renewalStatusValue } = this.model.getQuestionsValues(['Renewal_Status']);
      const isRenewalStatus = ['Send to Customer', 'Pending Bind'].includes(renewalStatusValue);
      return isRenewal && isRenewalStatus;
    };

    const checkCustomerTypeValid = () => {
      const customerType = this.model.getQuestionById('Application_Type');
      if (customerType?.value === 'Type2') return false;
      return true;
    };
    try {
      apiService.lock();
      const isCustomerTypeValid = checkCustomerTypeValid();
      if (!isCustomerTypeValid) throw { functionName, success: false, message: 'Customer type validation failed' };
      const isRenewalMail = checkIfRenewalMail();
      if (!isRenewalMail) throw { functionName, success: false, message: 'Not a renewal' };
      let isMaxPolicyLimitReached = null;
      const qId = this.getQid();
      const isMaxPolicyLimitReachedResponse = await this.checkIfMaxPolicyLimitReached({ qId });
      if (isMaxPolicyLimitReachedResponse.success) {
        isMaxPolicyLimitReached = isMaxPolicyLimitReachedResponse.value === true ? true : false;
      } else {
        this.deps.apiService.unlock();
        throw { functionName, success: false, message: 'Max policy validation failed. Please try again.' };
      }
      // we use sendRenewalMail() only if the renewal status is "Send to Customer" or "Pending Bind".
      // if we're in renewal but for some reason the status is different, no action is performed.
      if (isRenewalMail && !this.isMta() && isMaxPolicyLimitReached === false && isCustomerTypeValid) {
        // update the payment method and option to the override values to make sure the quote on zoho, which 
        // references the payment method and option, is correct
        this.assignRenewalOverrideValuesToPaymentMethodAndOption();
        await this.flushPatchQueue();
        // send the renewal mail
        return await mailService.sendRenewalMail(qId);
      } else {
        throw { functionName, success: false, message: 'max Policy limit reached.' };
      }
    } catch (error: any) {
      this.showErrorsAsPopup(error?.message ? `Error sending renewal quote due to: ${error?.message}` : 'Error sending renewal quote');
      console.error('error:', error);
      return { success: false, message: 'Error sending renewal quote' };
    } finally {
      apiService.unlock();
    }
  }

  public getChargeProcessingFee() {
    return this.chargeProcessingFee;
  }

  public setChargeProcessingFee(chargeProcessingFee: boolean) {
    this.chargeProcessingFee = !!chargeProcessingFee;
  }

  public setDataUpdatedForMta(value: boolean) {
    this.dataUpdatedForMta = value;
  }

  public getDataUpdatedForMta() {
    return this.dataUpdatedForMta;
  }

  public get isRenewal() {
    return this.checkIfRenewal();
  }

  public setMTARatesNotEqual(value: boolean) {
    this.MTARatesNotEqual = value;
  }
  
  public getMTARatesNotEqual() {
    return this.MTARatesNotEqual;
  }

  private setStormStates(stormStates: State[]) {
    this.stormStates = stormStates;
  }

  private createListQuestionComponentsToQuestionIdsMap = () => {
    // create a map of list question components to their sub questionIds. This is used to remove the error message from the custom element when its sub-question is valid.
    // in the schema this component has listQuestions array in the question metadata
    const listQuestionComponents = this.model.getQuestions().filter((q) => q.metadata?.listQuestions);
    const listQuestionIds = listQuestionComponents.map(
      (item: any & { property: string; }) => {
        const firstListQids = item.metadata?.listQuestions.map((q: any) => q.property);
        const secondListQids = item.metadata?.listSecondQuestions.map((q: any) => q.property);
        return [...firstListQids, ...secondListQids];
      });
    const listQuestionComponentsToQuestionIdsMap = new Map<string, string[]>();
    for (const q of listQuestionComponents) {
      listQuestionComponentsToQuestionIdsMap.set(q.questionId, listQuestionIds[listQuestionComponents.indexOf(q)]);
    }
    this.listQuestionComponentsToQuestionIdsMap = listQuestionComponentsToQuestionIdsMap;
  };

  private onQuestionUpdate = (question: Question) => {
    if (!['left_section', 'last_section', 'device_type'].includes(question.questionId)) {
      this.model.setLeftSection(this.model.getActiveSectionName());
    }
    // we removed Driver_License_First_Name from driverFields since it's not needed on the Samba side, and should not trigger another Samba call
    const driverFields = [
      'owner_name',
      'Driver_License_Last_Name',
      'driver_birth_date',
      'driving_license_state',
      'driving_license_number',
      'has_driving_license',
    ];
    if (driverFields.includes(question.questionId)) {
      this.updated = true;
    }

    /** Owner address */
    const ownerAddressAutocompleteUpdatedFields = ['state', 'owner_zip_code'];
    if (ownerAddressAutocompleteUpdatedFields.includes(question.questionId)) {
      this.ownerAddressAutocompleteUpdated = true;
    }
    /** Garage address */
    const garageAddressAutocompleteUpdatedFields = ['garage_state', 'garage_zip_code'];
    if (garageAddressAutocompleteUpdatedFields.includes(question.questionId)) {
      this.garageAddressAutocompleteUpdated = true;
    }

    if (question.questionId == 'manufacture_year' || question.questionId == 'userDefinedBoatValue' || question.questionId == 'UserOverrideBoatValue') {
      const validCoverages = this.model.getCoverageTypes();
      const coveragesQuestion = this.model.getQuestionById('Physical_Damage_Settlement_option');
      if (!validCoverages.find((i) => i.value == coveragesQuestion?.value) && this.overrideUWrule('InvalidCoverage')) {
        this.model.getQuestionById('Is_Package_Customized')!.value = '$_BOOL_false';
        this.model.getQuestionById('package')!.value = '';
        this.model.getQuestionById('Physical_Damage_Settlement_option')!.value = validCoverages[0].value;
      }
    }
  };

  private async patch(question: Question) {
    if (this.questionnaireId) {
      const data = { q: question.questionId, a: question.lastValidValue() };
      const result = question.type === 'customList' ? await this.deps.apiService.queueHttp('/question', data) : await this.deps.apiService.http('/question', data);
      if (result.sync) {
        eventBus().emit(Events.Type.ListRemoteUpdated, {
          listName: result.sync,
          items: result.value,
        });
      }
    }
  }

  private addToPatchQueue(question: Question) {
    const id = question.questionId == 'overrideValue' ? 'value' : question.questionId;
    this.patchQueue.set(id, question);
  }

  private async sendPatchQueue() {
    this.flushPatchQueue();
  }

  public async flushPatchQueue() {
    this.createListQuestionComponentsToQuestionIdsMap();
    const checkIfQuestionIsListQuestion = (questionId: string) => {
      if (!this.listQuestionComponentsToQuestionIdsMap) return undefined;
      for (const [key, value] of this.listQuestionComponentsToQuestionIdsMap) {
        if (value.includes(questionId)) {
          return key;
        }
      }
      return undefined;
    };
    const validateQuestionBeforePatch = (fields: any) => {
      const keys = Object.keys(fields);
      for (const key of keys) {
        const question = this.model.getQuestionById(key);
        if (question?.validator) {
          const isValid = question.validator.validate(fields[key]);
          if (!isValid) {
            eventBus().emit(Events.Type.SingleQuestionInvalid, { questionId: key, errMessage: question.validator.errors[0] });
            // remove the invalid question from the fields object to prevent sending it to zoho
            // delete fields[key];
          } else {
            // this is used to remove the error message from the custom element when its sub-question is valid.
            const masterQuestionId = checkIfQuestionIsListQuestion(key) || key;
            // this is used to reset the error message if the question is valid
            eventBus().emit(Events.Type.SingleQuestionValid, { questionId: masterQuestionId });
          }

          //validate Layup1_From, Layup1_To, Layup2_From, Layup2_To to be in the correct format of YYYY-MM-DD using regex, making sure the year is current or next year
          if (key == 'Layup1_From' || key == 'Layup1_To' || key == 'Layup2_From' || key == 'Layup2_To') {
            const date = fields[key];
            if (date) {
              const regex = new RegExp(/^(20[2-9][0-9])-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/);
              const passedTest = regex.test(date);
              if (!passedTest) {
                eventBus().emit(Events.Type.SingleQuestionInvalid, { questionId: 'layup_info', errMessage: 'Invalid date format', subQuestionId: key });
                // remove the invalid question from the fields object to prevent sending it to zoho
                delete fields[key];
              }
            }
  
  
          }
        }
      }
    };
    if (!this.isLoggedIn || !this.questionnaireId) return;

    const patchArr = Array.from(this.patchQueue).map((m) => m[1]).filter((q) => q.type != 'customList');
    const customArr = Array.from(this.patchQueue).map((m) => m[1]).filter((q) => q.type == 'customList');
    this.patchQueue = new Map<string, Question>();
    const fields = patchArr.reduce((obj, q) => ({ ...obj, [q.questionId]: q.lastValidValue() }), {});
    const questionnaireId = this.model.getQuestionnaireId();
    if (Object.keys(fields).length > 0) {
      try {
        validateQuestionBeforePatch(fields);
        // this updates all the questions in the fields object in parallel
        await this.deps.apiService.http('/questions', { fields, questionnaireId });
      } catch (err: any) {
        if (err?.response?.status == 409) {
          await this.showErrorsAsPopup('We currently not supporting updating more than one application in parallel');
          eventBus().emit(Events.Type.GoToWebsite, { url: window.location.href });
        }
      }
    }
    // this updates each custom list question separately, waiting for each update to finish before moving to the next
    for (const question of customArr.values()) {
      await this.patch(question);
    }
    return await this.deps.apiService.waitForFlushComplete();
  }

  public async setStatus(status: string) {
    if (this.questionnaireId) {
      const data = {
        status: status,
      };
      this.deps.apiService.http('/status', data);
    }
  }

  setAgentStates(states: State[] | undefined) {
    this.allowedToSellAgent = states || [];
  }

  setAgencyStates(states: State[] | undefined) {
    this.allowedToSellAgency = states || [];
  }

  public checkRenewalBillingAllowed() {
    const isBillingAllowed = this.model.getQuestionById('Renewal_Status')?.value === 'Pending Bind';
    return isBillingAllowed;
  }

  public assignOriginalPaymentOptionValueToPaymentOption() {
    try {
      // return if not MTA
      if (this.getMtaOrRenewalFlagWhenBothAreChecked() !== 'MTA') return;
      const originalPaymentOptionQuestion = this.model.getQuestionById('Original_Payment_Option');
      const paymentOptionQuestion = this.model.getQuestionById('Payment_option');
      if (paymentOptionQuestion) paymentOptionQuestion.value = originalPaymentOptionQuestion && originalPaymentOptionQuestion.value;
      return { success: true, message: 'Original payment option value assigned to payment option' };
    } catch (error: any) {
      const errorText = error?.message || 'Error assigning Original Payment Option question value to the Payment Option question value on moving to the last MTA screen';
      const data: WebSectionTrackingData = {
        section: 'S_Billing',
        next_section: '',
        operation: 'next',
        errorMessage: errorText,
        sendToSlackOnly: true,
        slackMessage: 'This means the agent will need to pay attention on the last MTA screen, since the Payment Option question value was not overridden to the Original Payment Option question value',
      };
      eventBus().emit(Events.Type.SaveWebSectionTracking, data);
      return { success: false, message: errorText };
    }
  }

  public assignRenewalOverrideValuesToPaymentMethodAndOption() {
    try {
      if (!this.checkIfRenewal()) throw { success: false, message: 'Not a renewal' };
      const paymentMethodQuestion = this.model.getQuestionById('Payment_method');
      const paymentOptionQuestion = this.model.getQuestionById('Payment_option');
      const paymentMethodOverride = this.model.getQuestionById('Renewal_User_Override_Payment_Method');
      const paymentOptionOverride = this.model.getQuestionById('Renewal_User_Override_Payment_Option');
      if (paymentMethodQuestion) paymentMethodQuestion.value = paymentMethodOverride && paymentMethodOverride.value;
      if (paymentOptionQuestion) paymentOptionQuestion.value = paymentOptionOverride && paymentOptionOverride.value;
      return { success: true, message: 'Override values assigned to payment method and option' };
    } catch  {
      throw { success: false, message: 'Error assigning override values to payment method and option' };
    }
  }

  public setPaymentMethodUpdatedInRenewal({ type }: { type: 'Bank Account' | 'Credit Card' | '', last4?: string; }) {
    this.updatedPaymentMethodType = type;
  }

  public getUpdatedPaymentMethodType() {
    return this.updatedPaymentMethodType;
  }

  public get paymentMethodQuestionId() {
    const paymentMethodQuestionId = this.checkIfRenewal() ? 'Renewal_User_Override_Payment_Method' : 'Payment_method';
    return paymentMethodQuestionId;
  }

  public get paymentOptionQuestionId() {
    const paymentOptionQuestionId = this.checkIfRenewal() ? 'Renewal_User_Override_Payment_Option' : 'Payment_option';
    return paymentOptionQuestionId;
  }

  public get paymentMethod() {
    let paymentMethod: PaymentMethod = this.model.getQuestionById(this.paymentMethodQuestionId)?.value as unknown as PaymentMethod;
    const isRenewal = this.getMtaOrRenewalFlagWhenBothAreChecked() === 'Renewal';
    // for renewal if the user updates the payment method, he is returned after the update to the renewal end screen but the renewal
    // was not completed yet. The new payment source has already been created in chargebee, but since the renewal hasn't completed yet,
    // the payment method is still the old payment method on the policy, that has been pulled from Chargebee on /hello.
    // so we need to override the payment method with the updated payment method type for the processing fee to be correctly calculated
    // all this unless the user wants to change the payment method again
    const userWantsToChangePaymentMethod = this.model.getQuestionById('Renewal_User_Override_Payment_Method_Change_YN')?.value === '$_BOOL_true';
    if (isRenewal && this.updatedPaymentMethodType && !userWantsToChangePaymentMethod) {
      paymentMethod = this.updatedPaymentMethodType === 'Credit Card' ? 'Credit_Card' : 'ACH';
    }
    return paymentMethod;
  }

  public get paymentOption() {
    const paymentOption = this.model.getQuestionById(this.paymentOptionQuestionId)?.value as unknown as BillingTerm;
    return paymentOption;
  }

  public checkIfRenewal() {
    const isRenewalValueRaw: any = this.model.getQuestionById('Is_Renewal')?.value;
    const isRenewal = BooleanValue.toNative(isRenewalValueRaw) && !this.isMta();
    return isRenewal;
  }

  public checkIsDev() {
    const watercraftName = this.model.getQuestionById('watercraft_name')?.value;
    const isString = typeof watercraftName === 'string';
    if (isString && ['ahoy-testing-dev', 'ahoy-dev'].includes(watercraftName)) return false;
    const isDev = !!(process.env.NODE_ENV && ['development', 'local'].includes(process.env.NODE_ENV));
    return isDev;
  }

  public isProcessingFeesMode(): boolean {
    const newPolicy = this.chargeProcessingFee;
    return newPolicy ? true : false;   
  }

  public get isOcr() {
    const ABtestingQuestion = this.model.getQuestionById('AB_Testing');
    const ABtestingQuestionAsJson = ABtestingQuestion?.value && typeof ABtestingQuestion?.value === 'string' && JSON.parse(ABtestingQuestion?.value);
    const isOcr = ABtestingQuestionAsJson?.ocr === 'with_form';
    return isOcr;
  }

  public get isOcrDataUsed() {
    const ocrDataQuestion = this.model.getQuestionById('ocr_boat_data');
    const isOcrDataUsed = !!ocrDataQuestion?.value;
    return isOcrDataUsed;
  }
 
  public get isUserSelectedOcr() {
    const userSelectedOcrQuestion = this.model.getQuestionById('User_Selected_Ocr');
    const isUserSelectedOcr = userSelectedOcrQuestion?.value === '$_BOOL_true';
    return isUserSelectedOcr;
  }

  public async uploadImageForOcr({ formData }: { formData: FormData; }) {
    let result;
    try {
      if (!formData || !formData.has('file')) {
        throw { value: false, msg: 'Missing file', errorType: 'OCR-image-upload-error' };
      }
      result = (await this.deps.apiService.uploadImageToOcr('/ocr/upload-image', formData)).data;
      // save the extractedData as json to the model
      const { extractedDataAsJson } = result.value;
      const ocrQuestion = this.model.getQuestionById('ocr_boat_data');
      if (ocrQuestion) ocrQuestion.value = extractedDataAsJson;
      return result?.success ? { success: true, message: t('T_Ocr_Image_Upload'), value: result?.value } : { success: false, message: t('E_Ocr_Image_Upload'), value: result?.value };
    } catch (err: any) {
      const data: WebSectionTrackingData = {
        section: 'S_Boat',
        next_section: '',
        operation: 'OCR-image-upload-error',
        errorMessage: err?.errorType || JSON.stringify(err, null, ' '),
      };

      eventBus().emit(Events.Type.SaveWebSectionTracking, data);
      return { success: false, message: t('E_Ocr_Image_Upload'), value: err?.errorType || JSON.stringify(err, null, ' ') };
    }
  }

  // This function checks if the user is an agent and decides if to show the exit popup 
  showBeforeExitPopup() {
    // For external agents don't show exit-popup and redirect to portal
    if (this.isExternalAgent()) {
      eventBus().emit(Events.Type.GoToWebsite, { url: '/portal' });
      return;
    }

    /** For customers and internal agents show exit-popup */
    const popupData: PopupData = {
      popupName: 'before-exit-popup',
      message: '',
      buttonText: 'Close',
      popupClassName: 'before-exit-popup',
    };

    eventBus().emit(Events.Type.ShowPopup, popupData);
  }

  // gets the logo used in lh-side-about-us-features
  getCustomLogo() {
    let response;
    const affiliateService = AffiliateService.getInstance();
    response = { imgAlt: ' logo', imgSrc: affiliateService?.getBrandLogo({}) };
    const removeAhoyLogo = affiliateService?.checkRemoveAhoyLogo();
    return { response, removeAhoyLogo };
  }

  public setEmarketmedId(emarketmed_id: string) {
    this.deps.gtmService.setEmarketmedId(emarketmed_id);
  }

  /** Send tracking data to Hubspot and Zoho */
  public async saveWebSectionTracking(data: WebSectionTrackingData) {
    if (this.model.getStatus() == 'Mem') return;

    /** Preparing data-for-hubspot */
    const hubData: QuestionsServiceTypes.HubData = {
      email: this.model.getQuestionById('email')?.value ?? '',
      timestamp: this.deps.gtmService.getTimestamp(),
      cookieValue: this.deps.gtmService.getCookie() ?? '',
    };

    /** Adding data-for-hubspot to data-for-zoho */
    Object.entries(hubData).forEach((el) => (data[el[0] as keyof QuestionsServiceTypes.HubData] = el[1]));

    // on congrats the qId is in the url, since the event that sets the qId is emitted after the tracking event, so model.getQuestionnaireId() will return undefined
    const qIdFromUrl = getQueryParam('questionnaireId');
    const questionnaireId = this.model.getQuestionnaireId() || this.questionnaireId || qIdFromUrl;
    const { apiService } = this.deps;
    // web section tracking
    apiService.http('/tracking/section', {
      ...data,
      ...{
        device_type: this.model.getQuestionById('device_type')?.value,
        questionnaireId,
      },
    });
  }

  // handle opening task for yacht-related errors
  private async handleOpeningTaskForYachtError() {
    const isDirect = await this.isDirectOrIndirectUser();
    const boatValue = this.model.getQuestionById('value')?.value || 0;
    // for direct user and boat value under 1M dollars, no task is created
    const skipTaskConditionsArr = [isDirect && +boatValue < 450000, isDirect && +boatValue >= 450000];
    // const skipTaskConditionsArr = [isDirect && +boatValue < 1000000];
    // if any of the conditions in the array is true, no task is created
    const skipTaskConditions = skipTaskConditionsArr.some(cond => cond);
    // if any of the conditions for not creating a task are met, return
    if (skipTaskConditions) {
      return;
    }
    // open task
    eventBus().emit(Events.Type.ReturnBackToCustomerTask, { popupComponentName: '', showConfiramtionMsgInPopup: false });
  }
   

  // Send notification data and opening task
  public async notifyTracking(data: any) {
    if (this.model.getStatus() == 'Mem') return;

    // on congrats the qId is in the url, since the event that sets the qId is emitted after the tracking event, so model.getQuestionnaireId() will return undefined
    const qIdFromUrl = getQueryParam('questionnaireId');
    const questionnaireId = this.model.getQuestionnaireId() || this.questionnaireId || qIdFromUrl;
    const owner_name = this.model.getQuestionById('owner_name')?.value;
    const { apiService } = this.deps;
    
    // opneing task
    const errorType = data.errorType || '';
    const errorIncludesYacht = errorType?.includes('_Yacht');
    if (errorType && errorIncludesYacht) {
      await this.handleOpeningTaskForYachtError();
    }

    // notify tracking
    const stream = data.notifyStream || 'lighthouseTracking';
    apiService.http('/tracking/notify', {
      ...data,
      ...{
        device_type: this.model.getQuestionById('device_type')?.value,
        questionnaireId,
        owner_name,
        stream,
        owner_phone: this.model.getQuestionById('owner_phone')?.value,
      },
    });
  }

  /** Send tracking data to Zoho */
  public async saveOtpTracking(
    operation: string,
    phone: string,
    code: string,
    name: string,
    email: string,
    errorMessage: string,
    userID: string,
    device_type: string,
  ) {
    const { apiService } = this.deps;
    const userAgent = window.navigator.userAgent;
    const queryParams = window.location.search.slice(1);
    const resolution = window.visualViewport?.width.toFixed(0) + 'x' + window.visualViewport?.height.toFixed(0);
    if (phone) {
      phone = phone.replace(' ', '');
    }

    const data = {
      operation,
      phone,
      name,
      email,
      code,
      errorMessage,
      userAgent,
      queryParams,
      resolution,
      device_type,
      userID,
    };
    apiService.http('/tracking/otp', data);
  }

  public async addListItem(question: QuestionCustomList, item: InsuredItems.IItem) {
    const { questionId } = question;
    const { apiService } = this.deps;
    apiService.lock();
    let result: InsuredItems.IItem;
    try {
      result = (await apiService.http(`/questions/list/${questionId}/add`, item)).data.item;
    } finally {
      apiService.unlock();
    }
    return result as InsuredItems.IItem;
  }

  public async updateListItem(question: QuestionCustomList, item: InsuredItems.IItem) {
    const { questionId } = question;
    const { apiService } = this.deps;
    let result: InsuredItems.IItem;
    try {
      result = (await apiService.http(`/questions/list/${questionId}/update`, item)).data.item;
    } catch  {
      result = item;
    }
    return result;
  }

  syncFromServer(data: any, overrides: any = {}) {
    if (data.questionnaireId) {
      this.questionnaireId = data.questionnaireId;
      eventBus().emit(Events.Type.QuestionnaireIdSet, data);
    } else {
      this.questionnaireId = undefined;
    }
    this.previewFiles = data.userdocs?.documents || {};
    this.model.init(data, overrides);
  }

  public handleError(result: any, chargeBeeError = false, chargeBeeErrorMessage = '') {
    //close open popup
    this.deps.popupService.closePopup();
    // on paymentLinkError, show error popup
    if (this.paymentLinkMode) {
      this.showErrorsAsPopup('Please try again later.');
      return;
    }
    //show error popup if from chargebee
    if (chargeBeeError) {
      debugger
      this.showErrorsAsPopup(chargeBeeErrorMessage ?? 'Action could not be completed', { instandaData: { instandaError: true, type: 'Technical' }, buttons: { number: 1, value: 'Try Again' } });
      return;
    }

    //get errors
    const errors: string[] = [];
    if (Array.isArray(result)) {
      result.forEach((error: string) => { errors.push(error); });
    }

    if (errors?.includes('UW_MIN_PACKAGE_VALUE')) {
      this.model.setLastError('UW_MIN_PACKAGE_VALUE');
    }
    else if (errors?.includes('UW_Error_42')) {
      this.model.setLastError('UW_Error_42');
    } 
    else if (errors?.includes('UW_Error_43')) {
      this.model.setLastError('UW_Error_43');
    } 
    else {
      this.model.setLastError('Instanda');
    }

    const instandaData: InstandaData = { instandaError: true, type: 'Technical' };
    this.showErrorsAsPopup(errors.join().replace(/['"]+/g, ''), { instandaData, buttons: { number: 1, value: 'Try Again' } });
  }

  changeQueryParams(name: string, value: string) {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    params.set(name, value);

    const paramsStr = params.toString() ? `?${params.toString()}` : '';

    if (window.location.hostname.startsWith('localhost')) {
      eventBus().emit(Events.Type.GoToWebsite, { url: `http://localhost:8000${paramsStr}` });
    } else {
      eventBus().emit(Events.Type.GoToWebsite, { url: window.location.origin + `/marina/index.html${paramsStr}` });
    }
  }

  removeQueryParams(paramName: string) {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    params.delete(paramName);

    const paramsStr = params.toString() ? `?${params.toString()}` : '';

    if (window.location.hostname.startsWith('localhost')) {
      eventBus().emit(Events.Type.GoToWebsite, { url: `http://localhost:8000${paramsStr}` });
    } else {
      eventBus().emit(Events.Type.GoToWebsite, { url: window.location.origin + `/marina/index.html${paramsStr}` });
    }
  }

  public showToast(toastEventData: ToastData) {
    if (!toastEventData) return;
    eventBus().emit(Events.Type.ShowToast, toastEventData);
  }

  async requestSectionChange(sectionName: string) {
    
    const currentSection = this.model.getActiveSectionName();
    let technicalDataFromYachtProgramCheck: TechnicalDataType | undefined;
    if (currentSection) {
      if (['S_Address'].includes(currentSection)) {
        let res;
        const deviceType = this.model.getQuestionById('device_type')?.value as string;
        /** Validate garage address on mobile */
        if (deviceType.toLowerCase() === 'mobile') {
          res = await this.validateAutocompleteAddress(1);
        } else {
          /** Validate owner and garage address on desktop */
          res = await this.validateAutocompleteAddress();
        }
        if (!res) return;
      }
      // DL section placement re-evaluation when leaving S_Boat. Runs BEFORE
      // validation so any layout mutation is reflected in the checks that
      // follow (e.g. section-order dependent validation).
      if (currentSection === 'S_Boat') {
        console.log('[DL-move] requestSectionChange from S_Boat — evaluating DL placement');
        await this.evaluateDriverLicenseSectionPlacement();
      }
      //new yacht program check will be called only if the model checks failed
      let valid = await this.checkIfValid(currentSection);
      const isStormStateErr = this.checkIfStateIsInStormStates();
      const isZipMorattoriumErr = this.checkIfZipInMoratorium();
      const isSameDayBindErr = valid.errorType === 'SameDayBind';
      const isPreviousDayBindErr = valid.errorType === 'PreviusDateBind';
      const isNoDrivingLicenseErr = valid.errorType === 'UW_Error_20';
      const isNoYachtProgramErr = valid.errorType && ['UW_Error_21D', 'UW_Error_23', 'UW_Error_24', 'UW_Error_24B', 'UW_Error_24C', 'Driver-Error'].includes(valid.errorType);
      if (!valid.value && !isPreviousDayBindErr && !isStormStateErr && !isSameDayBindErr && !isNoDrivingLicenseErr && !isNoYachtProgramErr && !isZipMorattoriumErr) {
        //new yacht program check
        const newYachtProgramValid = await this.checkIfValidForNewYachtProgram({ currentSection, originalErrCode: valid.errorType });
        if (!newYachtProgramValid.value) {
          valid = newYachtProgramValid;
          technicalDataFromYachtProgramCheck = newYachtProgramValid.technicalData;
        }
      }
      //Section is valid
      if (valid.value) {
        if (this.getCheckByState() && this.checkIfStateIsInStormStates()) {
          const toastEventData: ToastData = {
            headerText: 'Due to a moratorium currently in place in your state, binding restrictions are temporarily in effect.',
            text: 'We are happy to offer you a non-binding price indication, which can later be converted into a policy once the moratorium has been lifted. We will notify you as soon as these restrictions are no longer in effect. Thank you for considering Ahoy! Insurance. Please stay safe during this time.',
            timeout: 15000,
            mobileShortMode: true,
          };
          eventBus().emit(Events.Type.ShowToast, toastEventData);
        }

        const ownerZip = this.model.getQuestionById('owner_zip_code')?.value as string;
        if (ownerZip && this.checkIfZipInMoratorium()) {
          const toastEventData: ToastData = {
            headerText: 'Your county is currently under binding restrictions.',
            text: 'Due to extreme weather conditions in your area, a moratorium (binding restrictions) has been put in place temporarily. We are happy to provide you with a quote at this time, however we are unable to bind coverage for you until the moratorium (binding restrictions) has been lifted. We will notify you once the restrictions have been lifted. Thank you for considering Ahoy! Insurance. Please stay safe during this time.',
            timeout: 15000,
            mobileShortMode: true,
          };
          eventBus().emit(Events.Type.ShowToast, toastEventData);
        }

        const package_test = this.model.getTestValue('packages');
        // we default the payment option to annual on regular flow. we don't change it on MTA or renewal
        const isMTAorRenewal = ['MTA', 'Renewal'].includes(this.getMtaOrRenewalFlagWhenBothAreChecked());
        if (!isMTAorRenewal && sectionName == 'S_Billing' && package_test == 'paid_in_full') {
          this.model.getQuestionById('Payment_option')!.value = 'Annual';
        }

        this.model.setActiveSection(sectionName);
        this.model.setLastError('');

        // DISABLED (claims are now refreshed inside requestRate at the rating sections instead):
        // Refresh the claims summary once per session, the first time the user advances while
        // past the boat section (new business + renewal, not MTA).
        // if (!this.claimsSummaryFetched && !this.isMta() && this.isPastSection('S_Boat', currentSection)) {
        //   this.claimsSummaryFetched = true;
        //   await this.fetchClaimsSummary();
        // }

        const totalPremium = this.model.getQuestionById('Total_Premium')?.value;
        const data: WebSectionTrackingData = {
          section: currentSection,
          next_section: sectionName,
          operation: 'next',
          errorMessage: '',
          revenue: totalPremium?.toString() || '0',
        };
        /**
         * Adding value (boat value) only on S_Boat.
         * Values on S_Pricing (package price) and S_Billing (final price) are added from the relevant components
         * because insurance-service can't be a dependency of question-service, (circular dependency).
        */
       
        if (['S_Boat'].includes(currentSection)) {
          const boatValueQuestion = this.model.getQuestionById('value');
          const boatValue = boatValueQuestion?.value;
          if (boatValue) data.value = boatValue.toString();

          // NOTE - the warnings below do not block the user; we collect every applicable
          // warning for this section and bullet-list them when more than one fires.
          // technicalData mirrors the same no-get-assistance-btn rule used for blocking errors.
          const sectionWarnings = this.getSectionWarnings(currentSection);
          if (sectionWarnings.length > 0) {
            this.showErrorsAsPopup(this.formatWarningsAsBulletedMessage(sectionWarnings), { technicalData: this.getTechnicalDataForWarnings(sectionWarnings) });
          }
        }
        if (['S_Boat_Garage'].includes(currentSection)) {
          const sectionWarnings = this.getSectionWarnings(currentSection);
          if (sectionWarnings.length > 0) {
            this.showErrorsAsPopup(this.formatWarningsAsBulletedMessage(sectionWarnings), { technicalData: this.getTechnicalDataForWarnings(sectionWarnings) });
          }
        }
         if (['S_Attestations'].includes(currentSection)) {
          const sectionWarnings = this.getSectionWarnings(currentSection);
          if (sectionWarnings.length > 0) {
            this.showErrorsAsPopup(this.formatWarningsAsBulletedMessage(sectionWarnings), { technicalData: this.getTechnicalDataForWarnings(sectionWarnings) });
          }
        }

        const deviceType = this.model.getQuestionById('device_type')?.value as string;
        const premium = this.getTotalPremium();

        /** On mobile, add the value to the data. on desktop, handled in lh-pricing-package-for-table */
        if (['S_Pricing'].includes(currentSection) && premium && deviceType.toLowerCase() === 'mobile') {
          data.value = premium.toString();
        }
        eventBus().emit(Events.Type.SaveWebSectionTracking, data);
      }
      //Section isn't valid - SameDayBind error
      else if (valid.errorType === 'SameDayBind') {
        this.startInsuranceToday();
      }
      //Section isn't valid
      else {
        this.model.setLeftSection(currentSection);
        this.model.setLastError(valid.errorType || 'UW-Error');
        const data: WebSectionTrackingData = {
          section: currentSection,
          next_section: sectionName,
          operation: 'UW-error',
          errorMessage: valid.msg,
        };
        const notifyData: NotifyData = {
          section: currentSection,
          next_section: sectionName,
          operation: 'UW-error',
          errorMessage: valid.msg,
          errorType: valid.errorType,
        };

        eventBus().emit(Events.Type.SaveWebSectionTracking, data);
        eventBus().emit(Events.Type.NotifyTracking, notifyData);
        let technicalData: TechnicalDataType = '';
        // we don't show the get assistance button for these errors, only next (OK) button
        if (valid.errorType && this.noGetAssistanceBtnErrorCodes.includes(valid.errorType)) {
          technicalData = 'no-get-assistance-btn';
        }
        if (valid.errorType === 'Underwriting_Approvals_Error') {
          const isBulletPopup = valid?.msg?.includes('Header_Text');
          if (isBulletPopup) {
            technicalData = 'specify-errors-as-bullets';
          }
        }
        if (technicalDataFromYachtProgramCheck) {
          technicalData = technicalDataFromYachtProgramCheck;
        }
        this.showErrorsAsPopup(valid.msg, { technicalData });
      }
    }
  }

  public startInsuranceToday(changeDateToToday: boolean = false) {
    this.changeToMemoryMode();
    if (changeDateToToday) {
      const today = new DateValue();
      this.model.getQuestionById('insurance_start_date')!.value = today.toString();
    }
    if (this.model.getValue('nklEffectiveDate') != this.model.getValue('insurance_start_date')) {
      this.model.getQuestionById('nklEffectiveDate')!.value = '';
      this.model.getQuestionById('nklCustomerName')!.value = '';
      this.model.getQuestionById('nklSignature')!.value = '$_BOOL_false';
      this.model.getQuestionById('nklDate')!.value = new DateValue().toString();
    } else {
      this.model.getQuestionById('nklSignature')!.value = '$_BOOL_true';
    }

    this.deps.popupService.showSectionLayoutPopup('S_NoKnownLoss', t('T_Submit'));
  }

  private replaceTextInMessage(msg: string): string {
    // replace with date
    const allowedPurchaseDateQuestion = this.model.getQuestionById('Allowed_Purchase_Date');
    const allowedPurchaseDate = allowedPurchaseDateQuestion?.value || '';
    if (allowedPurchaseDate && typeof allowedPurchaseDate === 'string') {
      // the date needs to be formatted to mm-dd-yyyy, it arrives as yyyy-mm-dd
      const dateParts = allowedPurchaseDate.split('-');
      const formattedDate = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
      msg = msg.replace('<Allowed Purchase Date>', formattedDate);
    } 
    return msg;
  }

  public async showErrorsAsPopup(msg: string, options: { instandaData?: InstandaData, buttons?: Record<string, any>, technicalData?:TechnicalDataType} = {}) {
    const { instandaData, buttons } = options;      
    let { technicalData } = options;      
    let buttonDefaultText = 'Ok';
    const errCode = msg && st(msg);
    // validation on payment link mode failure, displaying a non-closable popup
    if (this.paymentLinkMode) {
      await this.deps.popupService.showPopup('non-eligible-popup', 'support-btn-only-non-closing-popup::', '', 'non-eligible-popup' );
      return;
    }
    //chargebee payment error
    if (['Action could not be completed'].includes(msg)) {
      await this.deps.popupService.showPopup('non-eligible-popup', msg, t('T_TryAgain'), 'non-eligible-popup-instanda');
      return;
    }
    // this is a reverse lookup from text to error code
    if (['UW_Error_42'].includes(errCode)) {
      technicalData = 'no-get-assistance-btn';
    }
    
    const question = this.model.getQuestionById('Underwriting_restriction_reason');
    if (['UW_MIN_PACKAGE_VALUE','UW_Error_42', 'UW_Error_43'].includes(msg)) {
      const errorCode = msg;
      msg = t(msg);
      if (['UW_Error_43'].includes(errorCode)) {
        msg = this.replaceTextInMessage(msg);
      }
    }
    question!.value = msg;
    let buttonText = 'T_TryAgain';
    const isAddBoatClickPopup = buttons?.popupName === 'AddBoatClick';
    if (buttons) {
      buttonText = buttons.number === 1 ? buttons.value : 'Ok';
      buttonDefaultText = isAddBoatClickPopup ? buttons.text : buttonDefaultText;
    }

    if (['UW_Error_43'].includes(errCode)) {
      msg = this.replaceTextInMessage(msg);
    }
    // if we have technical data, we concat it to msg following ::
    if (technicalData) {
      msg = `${technicalData}::${msg}`;
    }
    if (isAddBoatClickPopup) {
      await this.deps.popupService.showPopup('non-eligible-popup-add-boat', msg, buttonDefaultText, 'non-eligible-popup-add-boat' );
      return;
    }
    if (instandaData?.instandaError) {
      if (instandaData.type === 'Technical') {
        // if we have a msg, we show it, otherwise we show Rate-Technical
        if (msg) {
          await this.deps.popupService.showPopup('non-eligible-popup', t(msg), buttonText, 'non-eligible-popup-instanda');
        } else {
          await this.deps.popupService.showPopup('non-eligible-popup', 'Rate-Technical', buttonText, 'non-eligible-popup-instanda');
        }
      }
      else
      { await this.deps.popupService.showPopup('non-eligible-popup', 'Rate', buttonText, 'non-eligible-popup'); }
    }
    else
    { await this.deps.popupService.showPopup('non-eligible-popup', t(msg), buttonDefaultText, 'non-eligible-popup'); }
  }

  public async showPopup(popupName: string) {
    return await this.deps.popupService.showPopup(popupName, '', 'T_TryAgain', popupName);
  }

  public async showPopupOnEvent( popupName: string = '', message: string = '', buttontext: string = '', popupClassName: string = '' ) {
    return await this.deps.popupService.showPopup(popupName, message, t(buttontext), popupClassName);
  }

  public setUserType(userType: UserType) {
    this.userType = userType;
  }

  public isExternalAgent(): boolean {
    return this.userType === 'externalAgent';
  }

  public setNot_allowed_to_use_Agents_Portal(not_allowed_to_use_Agents_Portal: boolean) {
    this.not_allowed_to_use_Agents_Portal = not_allowed_to_use_Agents_Portal;
  }
  public async showNot_allowed_to_use_Agents_PortalPopup (){
    await this.deps.popupService.showPopup('non-eligible-popup', 'no-closing-popup-no-btns::It seems like you do not have the correct permissions to access this page, please contact your administrator if you think this is an error', '', 'non-eligible-popup' );
    // await this.deps.popupService.showPopup("non-eligible-popup", "you do not have access", "22222", "", "non-eligible-popup");

  }
  public getNot_allowed_to_use_Agents_Portal(): boolean {
    return this.not_allowed_to_use_Agents_Portal;
  }

  public isAgent(): boolean {
    return this.userType === 'agent';
  }

  public isAgentOrExternalAgent(): boolean {
    const isExternalAgent = this.isExternalAgent() || false;
    const isAgent = this.isAgent() || false;
    const isAgentOrExternalAgent = isAgent || isExternalAgent;
    return isAgentOrExternalAgent;
  }

  public isPaymentMode(): boolean {
    return getQueryParam('user_mode') === 'payment';
  }

  public getQid(): string {
    return this.questionnaireId ?? '';
  }

  public getCustomerType() {
    return this.model.getCustomerType();
  }

  public getCheckByState() {
    return this.model.getCheckByState();
  }

  public isTestApp(suffix?: string): boolean {
    return this.model.isTestApp(suffix);
  }

  public isMta(): boolean {
    return this.model.getQuestionById('Is_MTA')?.value == '$_BOOL_true';
  }

  // on MTA to a renewal both flags are checked, but the UI needs to treat it as MTA.
  // same logic as in lh-header-mta
  public getMtaOrRenewalFlagWhenBothAreChecked(): 'MTA' | 'Renewal' | '' {
    return this.isMta() ? 'MTA' : this.checkIfRenewal() ? 'Renewal' : '';
  }


  public checkIfStateIsV1({ state }: { state: State }) {
    const v1States = getV1States();
    if (!Array.isArray(v1States) || v1States.length < 1) return { success:false, value: false };
    return { success: true, value: v1States.includes(state) };
  }

  // Type guard function to check if a string is a valid State
  public isStateCode(stateCode: any): stateCode is State {
    const validStates: State[] = [
      'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 
      'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 
      'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY', 'FM', 'MH', 'MP', 'PW',
    ];
    return validStates.includes(stateCode);
  }

  public getProgramVersion() {
    const programVersion = this.model.getQuestionById('Program_Version')?.value;
    switch (programVersion) {
      case 'V1':
      case '':
        return 'V1';
      case 'V2':
        return 'V2';
      default:
        return null;
    }
  }

  private noAnnualDiscountStates = ['CA'];
  private noAnnualDiscountStatesNoNotes = { Payment_option: 'Annual' };

  /**
   * This function is used to check if a question can show the option's note.
   * @param qId - the question id
   * @param optionValue - the option value
   * @returns true if the question doesn't need to show the option's note.
   */
  public checkInNoAnnualDiscountStatesNoNotes = ({ questionId, optionValue }: any) => {
    for (const [key, value] of Object.entries(this.noAnnualDiscountStatesNoNotes)) {
      if (questionId === key && optionValue === value) {
        return true;
      }
    }
    return false;
  };
  /**
   * This function is used to check if the state is in the no annual discount states.
   * @returns true if the state is in the no annual discount states.
   */
  public checkInNoAnnualDiscountStates = () => {
    const state = this.getCheckByState();
    return this.noAnnualDiscountStates.includes(state);
  };

  /**
   * This helper function checks the AbTesting condition.
   * @param package_test - the package test value, as part of the AbTesting.
   * @param isNotTestValue - the value to display when the package test is not 'paid_in_full'.
   * @returns the value to display or empty string.
   */
  private packageTestData({ package_test, isNotTestValue, byPassTest }: any) {
    if (byPassTest) return isNotTestValue;
    const isTest = package_test == 'paid_in_full';
    const isTestValue = '';
    return isTest ? isTestValue : isNotTestValue;
  }

  /**
   * This function is used to get the html of the annual disount payment.
   * @param package_test - the package test value, as part of the AbTesting.
   * @param isNotTestValue - the value to display when the package test is not 'paid_in_full'.
   * @param keepOnMTA - MTA check is skipped, the value will display on MTA flow if meets the states condition.
   * @returns  the value to display or empty string.
   */

  public getPayLessOnAnnualContainerHTML({ package_test = '', isNotTestValue, keepOnMTA = false, byPassTest = false }: any) {
    let isMTA = this.model.getQuestionById('Is_MTA')?.value === '$_BOOL_true';
    if (keepOnMTA) {
      isMTA = false;
    }
    const isInNoAnnualDiscountStates = this.checkInNoAnnualDiscountStates();
    return isInNoAnnualDiscountStates || isMTA ? '' : this.packageTestData({ package_test, isNotTestValue, byPassTest });
  }

  private approvedUWApprovals: string[] = [];

  public setApprovedUWApprovals(approved: string[]) {
    this.approvedUWApprovals = approved || [];
  }

  // Agency-driven flag from /hello. When true (and boat isn't yacht-eligible),
  // the DL section is moved from S_Driver (before pricing) into S_Boater
  // (after pricing) at runtime — mirroring the schema override that
  // `driver::after_pricing_DEPRECIATED` applies at build time.
  private canMoveDriverLicenseSection = false;
  private driverSectionCurrentlyMoved = false;
  // Snapshot captured lazily on first apply so revert can restore the model
  // to its pristine (before-pricing) shape.
  private pristineDriverSchemaSnapshot: {
    sectionsGroups: string[][];
    sectionsFlat: any[];
    abTestingRaw: string | undefined;
  } | null = null;

  public setCanMoveDriverLicenseSection(v: boolean) {
    this.canMoveDriverLicenseSection = !!v;
    console.log('[DL-move] setCanMoveDriverLicenseSection', { canMoveDriverLicenseSection: this.canMoveDriverLicenseSection });
  }

  // Runs when the user leaves S_Boat.
  // DL section should be moved (not-yacht case) or restored (yacht case).
  public async evaluateDriverLicenseSectionPlacement() {
    if (!this.canMoveDriverLicenseSection) {
      console.log('[DL-move] evaluate skipped — canMoveDriverLicenseSection=false');
      return;
    }
    const isYacht = (this.model as any).boatQualifiesForYachtProgram?.() === true;
    const shouldBeMoved = !isYacht;
    const boatSnapshot = this.getQuestionsValues(['boatType', 'length', 'value', 'max_speed', 'manufacture_year']);
    console.log('[DL-move] evaluate', {
      isYacht,
      shouldBeMoved,
      driverSectionCurrentlyMoved: this.driverSectionCurrentlyMoved,
      boatSnapshot,
    });
    if (shouldBeMoved && !this.driverSectionCurrentlyMoved) {
      console.log('[DL-move] → apply');
      await this.applyDriverSectionMove();
    } else if (!shouldBeMoved && this.driverSectionCurrentlyMoved) {
      console.log('[DL-move] → revert');
      await this.revertDriverSectionMove();
    } else {
      console.log('[DL-move] no-op — state already matches');
    }
  }

  private captureDriverSchemaSnapshotIfNeeded() {
    if (this.pristineDriverSchemaSnapshot) return;
    console.log('[DL-move] capturing pristine snapshot for revert');
    const model: any = this.model;
    this.pristineDriverSchemaSnapshot = {
      sectionsGroups: JSON.parse(JSON.stringify(model.sectionsGroups || [])),
      // Flat list on the base ServerQuestionsModel — drives getSectionAfter,
      // getSectionBefore, and navigation. Must be mutated in lockstep with
      // sectionsGroups or "next" navigation goes to a section the header
      // no longer shows.
      sectionsFlat: JSON.parse(JSON.stringify(model.sections || [])),
      abTestingRaw: this.model.getQuestionById('AB_Testing')?.value as string | undefined,
    };
  }

  private async applyDriverSectionMove() {
    this.captureDriverSchemaSnapshotIfNeeded();
    const model: any = this.model;

    // 1) Strip S_Driver out of every section group so it disappears from the
    //    pre-pricing group.
    const strippedGroups: string[][] = (model.sectionsGroups || []).map((group: string[]) =>
      group.filter((s: string) => s !== 'S_Driver'),
    );

    // 2) Prepend S_Driver to group 1 (right before S_Boater). If for some
    //    reason group 1 doesn't exist (test data / atypical schema), fall
    //    back to appending it to the last group so it's still reachable.
    if (strippedGroups.length > 1) {
      strippedGroups[1] = ['S_Driver', ...strippedGroups[1]];
    } else if (strippedGroups.length === 1) {
      strippedGroups.push(['S_Driver']);
    } else {
      strippedGroups.push(['S_Driver']);
    }
    model.sectionsGroups = strippedGroups;

    // 3) Reorder the flat `sections` list on the base model so
    //    getSectionAfter/getSectionBefore navigate through
    //    S_Pricing → S_Driver → S_Boater. Remove S_Driver from wherever it
    //    sits, then insert it right before S_Boater. If S_Boater isn't in
    //    the list, S_Driver stays where it was removed from's index (append).
    if (Array.isArray(model.sections)) {
      const driverEntry = model.sections.find((s: any) => s?.sectionId === 'S_Driver');
      const withoutDriver = model.sections.filter((s: any) => s?.sectionId !== 'S_Driver');
      const sBoaterIdx = withoutDriver.findIndex((s: any) => s?.sectionId === 'S_Boater');
      if (driverEntry) {
        if (sBoaterIdx >= 0) {
          withoutDriver.splice(sBoaterIdx, 0, driverEntry);
        } else {
          withoutDriver.push(driverEntry);
        }
      }
      model.sections = withoutDriver;
    }

    // 4) Mutate AB_Testing.driver → 'after_pricing_DEPRECIATED' so downstream
    //    consumers (validateForRating skipping S_Driver at packages/customization,
    //    coherentDataService stubbing License_Status) see the moved state.
    await this.mutateAbTestingDriver('after_pricing_DEPRECIATED');

    this.driverSectionCurrentlyMoved = true;
    console.log('[DL-move] applied — sectionsGroups now', {
      sectionsGroups: JSON.parse(JSON.stringify(model.sectionsGroups)),
      sectionsFlatIds: (model.sections || []).map((s: any) => s?.sectionId),
      abTestingRaw: this.model.getQuestionById('AB_Testing')?.value,
    });
    eventBus().emit(Events.Type.RefreshHeader, this.model.getCustomerType());
  }

  private async revertDriverSectionMove() {
    if (!this.pristineDriverSchemaSnapshot) {
      console.log('[DL-move] revert skipped — no snapshot');
      return;
    }
    const snap = this.pristineDriverSchemaSnapshot;
    const model: any = this.model;

    model.sectionsGroups = JSON.parse(JSON.stringify(snap.sectionsGroups));
    // Restore the flat sections list so navigation (getSectionAfter/before)
    // sees S_Driver at its original position (between S_Owner and S_Pricing).
    model.sections = JSON.parse(JSON.stringify(snap.sectionsFlat));

    // Restore AB_Testing to the value that was there before we mutated it.
    await this.restoreAbTestingFromSnapshot();

    this.driverSectionCurrentlyMoved = false;
    console.log('[DL-move] reverted — sectionsGroups restored to', {
      sectionsGroups: JSON.parse(JSON.stringify(model.sectionsGroups)),
      sectionsFlatIds: (model.sections || []).map((s: any) => s?.sectionId),
      abTestingRaw: this.model.getQuestionById('AB_Testing')?.value,
    });
    eventBus().emit(Events.Type.RefreshHeader, this.model.getCustomerType());
  }

  private async mutateAbTestingDriver(newDriverValue: string) {
    const abTestingQ: any = this.model.getQuestionById('AB_Testing');
    if (!abTestingQ) {
      console.warn('[DL-move] mutateAbTestingDriver: AB_Testing question not found');
      return;
    }
    const currentRaw: string = (abTestingQ.value as string) || '';
    let current: any = {};
    try { current = currentRaw ? JSON.parse(currentRaw) : {}; } catch { current = {}; }
    const previousDriver = current.driver;
    current.driver = newDriverValue;
    const newRaw = JSON.stringify(current);
    abTestingQ.value = newRaw;
    console.log('[DL-move] AB_Testing.driver mutated', { from: previousDriver, to: newDriverValue, newRaw });
    // Fire-and-forget Zoho patch — non-blocking so section transitions stay snappy.
    this.deps.apiService.http('/question', { q: 'AB_Testing', a: newRaw })
      .then(() => console.log('[DL-move] AB_Testing patched to Zoho', { newRaw }))
      .catch((err: any) => {
        console.warn('[DL-move] Failed to patch AB_Testing to Zoho, continuing', err);
      });
  }

  private async restoreAbTestingFromSnapshot() {
    if (!this.pristineDriverSchemaSnapshot) return;
    const originalRaw = this.pristineDriverSchemaSnapshot.abTestingRaw;
    const abTestingQ: any = this.model.getQuestionById('AB_Testing');
    if (!abTestingQ) {
      console.warn('[DL-move] restoreAbTestingFromSnapshot: AB_Testing question not found');
      return;
    }
    abTestingQ.value = originalRaw;
    console.log('[DL-move] AB_Testing restored from snapshot', { originalRaw });
    this.deps.apiService.http('/question', { q: 'AB_Testing', a: originalRaw })
      .then(() => console.log('[DL-move] AB_Testing restore patched to Zoho', { originalRaw }))
      .catch((err: any) => {
        console.warn('[DL-move] Failed to restore AB_Testing on Zoho, continuing', err);
      });
  }

  public overrideUWrule(errorCode: string): boolean {
    const override_UW_rules: string = (this.model.getQuestionById('override_UW_rules')!.value as string) || '';
    const override_UW_rules_Arr = override_UW_rules.split(',').map((i) => i.trim());

    if (override_UW_rules_Arr.includes(errorCode)) {
      return false;
    }
    // suppress UW errors that have already been approved (matched against approvedUWApprovals from /insure/get-uw-approvals or rate refresh)
    if (this.approvedUWApprovals.includes(errorCode)) {
      return false;
    }
    return true;
  }

  /**
   * Collect all warning errors applicable to currentSection. Mirrors the warning conditions
   * inside checkIfValid but does NOT early-return — gathers everything that matches so the
   * popup can list multiple warnings as bullets when several apply at once.
   */
  // When a boat-value UW warning is surfaced (UW_Error_35/35A/46/46A, and 52A/52B
  // once the user proceeds past the override-value warning popup), reset the
  // OpenAI value-inference fields and stamp Compound_Boat_Data with the current
  // boat descriptor so the OpenAI pipeline re-runs from clean state. Idempotent:
  // skips the patch when Compound_Boat_Data already matches what we'd write.
  // Fire-and-forget — never blocks the warning surfacing.
  // Public so lh-block can invoke this on the Continue-button hook for 52A/52B.
  public patchOpenAIFieldsForBoatValueUWWarning() {
    const functionName = 'patchOpenAIFieldsForBoatValueUWWarning';
    try {
      const vals = this.getQuestionsValues(['make', 'model', 'manufacture_year', 'length', 'numberOfEngine', 'horsepower', 'value']);
      const fmt = (v: any) => (v === null || v === undefined || v === '') ? 'null' : String(v);
      // Coerce Value to number-or-null so the JSON encoding matches the
      // renewal-clone stamp and the backend freshness check regardless of
      // whether getQuestionsValues returned a string ("150000") or a number.
      const toNumOrNull = (v: any): number | null => {
        if (v === null || v === undefined || v === '') return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };
      const boatDataString = `boat ${fmt(vals.make)} ${fmt(vals.model)} ${fmt(vals.manufacture_year)} length ${fmt(vals.length)} feet ${fmt(vals.numberOfEngine)} engine/s ${fmt(vals.horsepower)}  HP`;
      const newCompound = JSON.stringify({ value: toNumOrNull(vals.value), boat_data: boatDataString });

      const currentCompound = this.model.getQuestionById('Compound_Boat_Data')?.value as string | undefined;
      if (currentCompound === newCompound) {
        console.log(`[${functionName}] Compound_Boat_Data matches — no patch needed`, { current: currentCompound });
        return;
      }

      const updates: Record<string, string> = {
        OpenAI_Upper_Limit: '',
        OpenAI_Lower_Limit: '',
        OpenAI_Avg_Value: '',
        OpenAI_Median_Value: '',
        OpenAI_Boat_Value_Status: '',
        Compound_Boat_Data: newCompound,
      };
      // Mirror the changes on the in-memory model so any later reads (e.g., a
      // re-run of this helper on the same section-change) see the new state
      // and skip an extra patch.
      for (const [qId, val] of Object.entries(updates)) {
        const q = this.model.getQuestionById(qId);
        if (q) q.value = val;
      }
      const questionnaireId = this.model.getQuestionnaireId();
      if (!questionnaireId) {
        console.warn(`[${functionName}] No questionnaireId — skipping Zoho patch`);
        return;
      }
      console.log(`[${functionName}] patching`, { updates, previousCompound: currentCompound });
      this.deps.apiService.http('/questions', { fields: updates, questionnaireId })
        .then(() => console.log(`[${functionName}] Zoho patch complete`))
        .catch((err: any) => console.warn(`[${functionName}] Zoho patch failed, continuing`, err));
    } catch (err: any) {
      console.warn(`[${functionName}] Error building payload, skipping`, err?.message);
    }
  }

  private getSectionWarnings(currentSection: string): { errorType: string, msg: string }[] {
    const warnings: { errorType: string, msg: string }[] = [];
    const supportPhone = this.model.getSupportPhoneNumberText();
    const {
      otherBoatModel,
      priceDigestValue,
      Is_MTA,
      Is_Renewal,
      boat_purchase_date,
      Physical_Damage_Settlement_option,
    } = this.getQuestionsValues(['otherBoatModel', 'priceDigestValue', 'Is_MTA', 'Is_Renewal', 'boat_purchase_date', 'Physical_Damage_Settlement_option']);

    if (currentSection === 'S_Boat') {
      const isAgent = !!this.model.getQuestionById('External_Agent')?.value;
      const shouldApplyNewErrorsToAgent = isAgent ? (this.model.getUW_Chunk() ? false : true) : true;
      const boatAge = this.model.getBoatAge(true);

      if (boatAge && boatAge >= 20 && this.overrideUWrule('UW_Error_51') && Is_MTA !== '$_BOOL_true') {
        warnings.push({ errorType: 'UW_Error_51', msg: t('UW_Error_51', supportPhone) });
      }
      // the warnings below are kind of linked together - if one warning occurs then the rest should not
      if (!isAgent && otherBoatModel == '$_BOOL_true' && !priceDigestValue && this.overrideUWrule('UW_Error_35') && Is_MTA !== '$_BOOL_true') {
        warnings.push({ errorType: 'UW_Error_35', msg: t('UW_Error_35', supportPhone) });
        this.patchOpenAIFieldsForBoatValueUWWarning();
      } else if (isAgent && shouldApplyNewErrorsToAgent && otherBoatModel == '$_BOOL_true' && !priceDigestValue && this.overrideUWrule('UW_Error_35A') && Is_MTA !== '$_BOOL_true') {
        warnings.push({ errorType: 'UW_Error_35A', msg: t('UW_Error_35A', supportPhone) });
        this.patchOpenAIFieldsForBoatValueUWWarning();
      }
      else if (isAgent && shouldApplyNewErrorsToAgent && !priceDigestValue && this.overrideUWrule('UW_Error_46A') && Is_MTA !== '$_BOOL_true') {
        warnings.push({ errorType: 'UW_Error_46A', msg: t('UW_Error_46A', supportPhone) });
        this.patchOpenAIFieldsForBoatValueUWWarning();
      }
      else if (!isAgent && !priceDigestValue && this.overrideUWrule('UW_Error_46') && Is_MTA !== '$_BOOL_true') {
        warnings.push({ errorType: 'UW_Error_46', msg: t('UW_Error_46', supportPhone) });
        this.patchOpenAIFieldsForBoatValueUWWarning();
      }
    }

    if (currentSection === 'S_Boat_Garage') {
      const isAgent = !!this.model.getQuestionById('External_Agent')?.value;
      const shouldApplyNewErrorsToAgent = isAgent ? (this.model.getUW_Chunk() ? false : true) : true;

      if (shouldApplyNewErrorsToAgent && Physical_Damage_Settlement_option === 'Replacement Cost' && boat_purchase_date === 'Within the last 12 months' && this.overrideUWrule('UW_Error_37')) {
        warnings.push({ errorType: 'UW_Error_37', msg: t('UW_Error_37', supportPhone) });
      }
      if (
        shouldApplyNewErrorsToAgent &&
        Physical_Damage_Settlement_option === "Agreed Value" &&
        (boat_purchase_date === '1 year to 3 years ago' || boat_purchase_date === 'Within the last 12 months') &&
        this.overrideUWrule('UW_Error_56')
      ) {
        warnings.push({ errorType: 'UW_Error_56', msg: t('UW_Error_56', supportPhone) });
      }
    }

    if (currentSection === 'S_Attestations' && Is_Renewal === '$_BOOL_true') {
      const boatAge = this.model.getBoatAge(true);
      if (boatAge && boatAge >= 20 && this.overrideUWrule('UW_Error_51')) {
        warnings.push({ errorType: 'UW_Error_51', msg: t('UW_Error_51', supportPhone) });
      }
    }

    return warnings;
  }

  /**
   * Decide the popup `technicalData` for a list of warnings. The Get Assistance button
   * is shown as soon as any warning is NOT in noGetAssistanceBtnErrorCodes (i.e., a single
   * warning that wants the button is enough to keep it visible). The button is hidden only
   * when every warning is in the no-get-assistance list.
   */
  private getTechnicalDataForWarnings(warnings: { errorType: string }[]): TechnicalDataType {
    if (warnings.length > 0 && warnings.every(w => this.noGetAssistanceBtnErrorCodes.includes(w.errorType))) {
      return 'no-get-assistance-btn';
    }
    return '';
  }

  /**
   * Format an array of warnings into a single popup message. Single warning → plain text;
   * multiple warnings → joined with `$_BULLET` separators (mirrors getUWApprovalsErrorMessage
   * in insurance-service.ts).
   */
  private formatWarningsAsBulletedMessage(warnings: { errorType: string, msg: string }[]): string {
    if (warnings.length === 0) return '';
    const errorCodes = warnings.map((w) => w.errorType);
    if (warnings.length === 1) return substituteUploadLinks(warnings[0].msg, errorCodes);

    const textResult: string[] = [];
    for (const w of warnings) {
      textResult.push(w.msg);
      textResult.push('$_BULLET');
    }
    if (textResult[textResult.length - 1] === '$_BULLET') textResult.pop();
    for (let i = 0; i < textResult.length - 1; i++) {
      textResult[i] = textResult[i].replace(/\.$/, '');
    }
    // Apply upload-link substitution at the composition point so a
    // multi-warning popup gets ONE link covering every needed doc type,
    // not one link per warning.
    return substituteUploadLinks(textResult.join('. '), errorCodes);
  }

  //@ts-ignore
  private isCoastal(): boolean {
    const ownerZipIsCoastal = this.model.getQuestionById('Owner_isCoastal')?.value === '$_BOOL_true';
    const garageZipIsCoastal = this.model.getQuestionById('Garage_isCoastal')?.value === '$_BOOL_true';
    const is_garage = this.model.getQuestionById('is_garaged')?.value === '$_BOOL_true';

    if (is_garage) {
      return this.garageZipIsCoastalChecked ? this.garageZipIsCoastal : garageZipIsCoastal;
    } else {
      return this.ownerZipIsCoastalChecked ? this.ownerZipIsCoastal : ownerZipIsCoastal;
    }
  }

  public getAffiliateValue() {
    this.affiliateService = AffiliateService.getInstance();
    const affiliate = this.affiliateService?.getAffiliate();
    return affiliate;
  }

  public isAffiliateExist(affiliateValue: string) {
    this.affiliateService = AffiliateService.getInstance();
    return this.affiliateService?.isAffiliateExist(affiliateValue);
  }

  public getIsChat() {
    return this.affiliateService?.getIsChat();
  }

  public getPhoneNumberAndEmailForAttestation():{phoneNumber:string, email:string} {
    const phoneNumber = this.model.getQuestionById('owner_phone')?.value as string|| '';
    const email = this.model.getQuestionById('email')?.value as string || '';
    return { phoneNumber, email };
  }

  // new yacht program check
  // this function is called after the server validations (checkIfValid) complete, which checks for the Yacht
  // conditions after S_Boat. This function checks it again in case later sections emit an error that might be
  // relevant to the Yacht Program. At this time this check might be viewed as redundant since all the params for checking
  // the conditions are known already after S_Boat, but it serves as a final validation step and is in charge of altering the error message text
  public async checkIfValidForNewYachtProgram({ currentSection, originalErrCode }: any): Promise<checkIfValidResponse> {
    const previousSections = this.model.getSections().slice(0, this.model.getSections().findIndex((s) => s.sectionId == currentSection) + 1).map((s) => s.sectionId);
    if (!previousSections.includes('S_Boat')) {
      return { value: true, msg: '' };
    }
    const { value }:any = { ...this.getQuestionsValues(['value']) };    
    if (originalErrCode && !this.noNewYachtProgramErrorCodes.includes(originalErrCode)) {
      const newYachtProgramError = this.model.validateUWforNewYachtProgram({ previousSections, originalErrCode });
      if (!newYachtProgramError.value) {
        const errorCode = newYachtProgramError.errorCode || 'Yacht_Program_Error';
        const isDirect = await this.isDirectOrIndirectUser();
        // on FALSE: return the Yacht_Different_Text msg
        // on TRUE: return 1 out the 2 new msgs, depending on boat value above or below 1M$.
        let msgText = newYachtProgramError.errorCode;
        if (!isDirect) {
          msgText = 'Yacht_Different_Text';
        }
        else {
          // in case of a direct customer, the error message depends on the boat value, being under 1M or above
          // we check if value is a valid number > 0
          const isValueValid = typeof value === 'number' && !isNaN(value) && value > 0;
          if (isValueValid) {
            const isBoatValueUnder1M = value < 450000;
            msgText = isBoatValueUnder1M ? 'Yacht_Direct_Under_1M' : 'Yacht_Direct_Equal_To_Or_Over_1M';
          }
        }
        let msg = t(msgText, this.model.getSupportPhoneNumberText());
        
        const response: { value: boolean; msg: string; errorType: string; technicalData?: TechnicalDataType; } = { value: false, msg, errorType: errorCode };
        // replace firstmate@ahoy.insure with a span the colors the email in #7068ac
        response.msg = msg = msg.replace('firstmate@ahoy.insure', '<span style="color: #7068ac; font-weight:900;" >firstmate@ahoy.insure</span>');
        response.technicalData = 'no-changing-quotes';
        // add the link
        if (!isDirect){
          const link = '<a href="https://ahoy.insure/wp-content/uploads/2025/09/ahoy-es-application.pdf" target="_blank" rel="noopener noreferrer" style="color: #7068ac; font-weight: 900;">here</a>';
          response.msg = msg.replace('here <(add link https://ahoy.insure/wp-content/uploads/2025/09/ahoy-es-application.pdf)>', link);
            // this is for dividing the 2 paragraphs
            response.msg = StringManipulation.splitToParagraphs(response.msg, 8);
        }
        else if (['Yacht_Direct_Under_1M', 'Yacht_Direct_Equal_To_Or_Over_1M'].includes(msgText)) {
          const link = '<a href="https://ahoy.insure/wp-content/uploads/2025/09/ahoy-es-application.pdf" target="_blank" rel="noopener noreferrer" style="color: #7068ac; font-weight: 900;">here</a>';
          response.msg = msg.replace('here <(add link https://ahoy.insure/wp-content/uploads/2025/09/ahoy-es-application.pdf)>', link);
        
          if (['Yacht_Direct_Under_1M'].includes(msgText)) {
            // this is for dividing the 2 paragraphs
            response.msg = StringManipulation.splitToParagraphs(response.msg, 8);
          }
        }
        return response;
      }
    }
    
    return { value: true, msg: '' };
  }

  private validateBoatInitials(): boolean {
    const customerApprovedBoatAttestationValue = this.model.getQuestionById('Approved_Manual_Data_Attestation')?.value;
    const otherBoatModelQuestionValue = this.model.getQuestionById('otherBoatModel')?.value;
    // we validate on load for existing apps in which the boat is not found in PD (boat data inserted manually by the user)
    // all new apps will need to check the attestation though, doesn't matter if the boat is found in PD or not
    // we don't validate for renewals
    // we don't validate for internal agents and external agents
    const isRenewal = this.getMtaOrRenewalFlagWhenBothAreChecked() === 'Renewal';
    const isInternalAgent = this.isAgent();
    const isExternalAgent = this.isExternalAgent();
    const invalidBoatInitials = customerApprovedBoatAttestationValue === '$_BOOL_false' && otherBoatModelQuestionValue === '$_BOOL_true' && !isRenewal && (!(isInternalAgent || isExternalAgent));
    return !invalidBoatInitials;
  }
  
  //new yacht program check will be called if the model checks failed
  public async checkIfValid(currentSection: string): Promise<checkIfValidResponse> {
    /** Bypass sections */
    if (['S_Welcome'].includes(currentSection)) return { value: true, msg: '' };

    const { boatType, value, External_Agent: externalAgent, has_driving_license, max_speed, insurance_start_date, MTA_start_date, Is_MTA, External_Agent, Current_Version_Effective_Date } = this.getQuestionsValues(['length', 'boatType', 'value', 'hullType', 'motorType', 'horsepower', 'numberOfEngine', 'manufacture_year', 'has_driving_license', 'max_speed', 'Number_of_Owners', 'insurance_start_date', 'External_Agent', 'MTA_start_date', 'Is_MTA', 'External_Agent', 'Current_Version_Effective_Date', 'Last_Premium', 'New_Rating_Premium']);

    const checkByState: State = this.getCheckByState();
    const isRenewal = this.checkIfRenewal();
    const previousSections = this.model.getSections().slice(0, this.model.getSections().findIndex((s) => s.sectionId == currentSection) + 1).map((s) => s.sectionId);

    this.model.setUserType(this.userType);
    if (previousSections.includes('S_Address') || previousSections.includes('S_Owner')) {
      if (this.model.setCustomerType(checkByState, this.allowedToSellAgent, this.allowedToSellAgency)) {
        eventBus().emit(Events.Type.RefreshHeader, this.model.getCustomerType());
      }
    }

    
    let error = this.model.validateUW(currentSection);
    const isMaxPolicyLimitError = ['UW_Error_34','UW_Error_34_Yacht'].includes(error.errorCode);
    if (isMaxPolicyLimitError) {
      // notify tracking
      const notifyData: NotifyData = {
        section: currentSection,
        next_section: '',
        operation: 'UW-error',
        errorMessage: error.errorCode,
        boatValue: value,
        notifyStream: 'over350kPoliciesAlerts',
      };
      eventBus().emit(Events.Type.NotifyTracking, notifyData);
    }
    // we don't want to check the Yacht program if the state is in storm states
    const isStormStateErr = this.checkIfStateIsInStormStates();
    const isZipMorattoriumErr = this.checkIfZipInMoratorium();
    if (!error.value && !isStormStateErr && !isZipMorattoriumErr && error.errorCode && !this.noNewYachtProgramErrorCodes.includes(error.errorCode)) {
      //new yacht program check 
      const newYachtProgramError = this.model.validateUWforNewYachtProgram({ previousSections, originalErrCode: error.errorCode });
      if (!newYachtProgramError.value) {
        // we want to delay Yacht program errors to be displayed only after the S_Address section, because
        // we need the address details for LORO. Since we allow moving to the Address section, we need to
        // validate the boat initials here too
        if (currentSection === 'S_Boat' && !previousSections.includes('S_Address')) {
          const isBoatInitialsValid = this.validateBoatInitials();
          if (!isBoatInitialsValid) {
            return { value: false, msg: t('UW_Error_36', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_36' };
          } else {
          // allow moving to the Address section
            return { value: true, msg: '' };
          }
        } else if (!previousSections.includes('S_Driver')){
            // allow moving to the driver section section
            return { value: true, msg: '' };
        }
        else {
          error = newYachtProgramError;
        }
      }
      // return the yacht program error
      if (!error.value) {      
        return { value: false, msg: t(error.errorCode, error.param), errorType: error.errorCode };
      }
    }
    // return the admitted product error
    if (!error.value) {
      return { value: false, msg: t(error.errorCode, error.param), errorType: error.errorCode };
    }

    if (previousSections.includes('S_Boat') || currentSection === 'S_Boat') {
      const isBoatInitialsValid = this.validateBoatInitials();
      if (!isBoatInitialsValid) {
        return { value: false, msg: t('UW_Error_36', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_36' };
      }
    }


    // S_Boat and S_Attestations (renewal) non-blocking warnings
    // (UW_Error_51, _35, _35A, _46, _46A) are evaluated and shown via
    // getSectionWarnings + the popup-show in requestSectionChange.

    if (previousSections.includes('S_Address')) {
      const boatAge = this.model.getBoatAge(true) || 0;
      const agentAllowed = this.allowedToSellAgent?.includes(checkByState) || false;
      const agencyAllowed = this.allowedToSellAgency?.includes(checkByState) || false;
      const stateFullName = getStateFullName(checkByState);
      const customerType = this.getCustomerType();
      if (customerType === 'Type3') {
        return { value: false, msg: t('UW_Error_1', stateFullName, this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_1' };
      }
      if (customerType === 'Type1' && !!externalAgent && this.userType === 'externalAgent' && (!agentAllowed || !agencyAllowed)) {
        if (!agentAllowed && !agencyAllowed) return { value: false, msg: t('UW_Error_24_Agency_And_Agent', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_24C' };
        else if (!agencyAllowed) return { value: false, msg: t('UW_Error_24_Agency', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_24B' };
        else return { value: false, msg: t('UW_Error_24', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_24' };
      }
      if (
        (boatAge > 30 || value > 350000) &&
        (['FL'].includes(checkByState) ||
          (this.isCoastal() && ['NC', 'SC', 'NY', 'MS', 'AL', 'TX', 'NJ'].includes(checkByState))) &&
        this.overrideUWrule('UW_Error_13')
      ) {
        return {value: false, msg: t('UW_Error_13', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_13'};
      }
    }

    const driver_test = this.model.getTestValue('driver');

    if ( (driver_test !== 'after_pricing_DEPRECIATED' && previousSections.includes('S_Driver')) || (driver_test === 'after_pricing_DEPRECIATED' && previousSections.includes('S_Boater')) ) {
      if (this.getCustomerType() == 'Type1' && !this.isTestApp()) {
        if (has_driving_license !== '$_BOOL_true' && driver_test !== 'after_pricing_DEPRECIATED') {
          return { value: false, msg: t('UW_Error_20', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_20' };
        }
      }
      if ( this.getCustomerType() == 'Type1' && (has_driving_license == '$_BOOL_true' || driver_test === 'after_pricing_DEPRECIATED') ) {
        const res = await this.validateDriver();
        if (!res.value && this.overrideUWrule(res.errorType))
          return { value: false, msg: res.msg, errorType: res.errorType };
      }
    }

    if (previousSections.includes('S_Boat_Garage')) {
      if (max_speed > 75 && !['BassBoat'].includes(boatType as string) && this.overrideUWrule('UW_Error_17'))
        return { value: false, msg: t('UW_Error_17', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_17' };
      if (max_speed > 90 && ['BassBoat'].includes(boatType as string) && this.overrideUWrule('UW_Error_18'))
        return { value: false, msg: t('UW_Error_18', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_18' };
      if (max_speed > 75 && ['FL'].includes(checkByState as string) && this.overrideUWrule('UW_Error_19'))
        return { value: false, msg: t('UW_Error_19', this.model.getSupportPhoneNumberText()), errorType: 'UW_Error_19' };
    }
    
    // S_Boat_Garage non-blocking warnings (UW_Error_37, _56) are evaluated and shown via
    // getSectionWarnings + the popup-show in requestSectionChange.

    if (previousSections.includes('S_Additional_Boaters')) {
      if (Is_MTA == '$_BOOL_false') {
        var from_date: DateValue = new DateValue();
        var current_date: DateValue = new DateValue();

        if (!(this.isAgent() || this.isExternalAgent() || External_Agent)) {
          from_date.addDays(2);
        }

        if (insurance_start_date < current_date && this.overrideUWrule('PreviusDateBind')) {
          return { value: false, msg: t('PreviusDateBind'), errorType: 'PreviusDateBind' };
        }

        if ( !isRenewal && insurance_start_date < from_date && (!this.model.getValue('nklCustomerName') || this.model.getValue('nklEffectiveDate') != insurance_start_date) ) {
          return { value: false, msg: t('SameDayBind'), errorType: 'SameDayBind' };
        }
      } else {
        if (new Date(Current_Version_Effective_Date) > new Date(MTA_start_date)) {
          return { value: false, msg: t('MTAstartDate'), errorType: 'MTAstartDate' };
        }

        var exp_date = new DateValue(insurance_start_date);
        exp_date.addYears(1);
        if (exp_date < MTA_start_date) {
          return { value: false, msg: t('MTAstartDateAfterExp'), errorType: 'MTAstartDateAfterExp' };
        }
      }
    }

    if (previousSections.includes('S_Summary_Details')) {
      if (this.checkIfStateIsInStormStates() && this.overrideUWrule('UW_Error_25')) {
        return { value: false, msg: t('UW_Error_25'), errorType: 'UW_Error_25' };
      }

      if (this.checkIfZipInMoratorium() && this.overrideUWrule('UW_Error_25Z')) {
        return { value: false, msg: t('UW_Error_25Z'), errorType: 'UW_Error_25Z' };
      }
      
      if (this.model.getQuestionById('Underwriting_Approvals_Cleared')!.value !== '$_BOOL_true' && this.overrideUWrule('Underwriting_Underwriting_Approvals_ErrorApprovals_Cleared')) {
        const errText: string = this.model.getQuestionById('Underwriting_Status_Text')!.value as string || '';
        return { value: false, msg: errText, errorType: 'Underwriting_Approvals_Error' };        
      }
    }
    
    if (['MTA','Renewal'].includes(this.getMtaOrRenewalFlagWhenBothAreChecked()) && previousSections.includes('S_MTA_Coverages')) {
      if (this.model.getQuestionById('Underwriting_Approvals_Cleared')!.value !== '$_BOOL_true' && this.overrideUWrule('Underwriting_Underwriting_Approvals_ErrorApprovals_Cleared')) {
        const errText: string = this.model.getQuestionById('Underwriting_Status_Text')!.value as string || '';
        return { value: false, msg: errText, errorType: 'Underwriting_Approvals_Error' };        
      }
    }

    return { value: true, msg: '' };
  }


  // used to check before referring to Yacht program
  public checkIfZipInMoratorium() {
    const fire_zips: any = this.model.getQuestionById('Fire_Zips')?.value as string[] || [];  
    // return false if fire_zips is empty
    if (fire_zips.length == 0) {
      return false;
    }
    const ownerZip = this.model.getQuestionById('owner_zip_code')?.value as string;
    const garageZip = this.model.getQuestionById('garage_zip_code')?.value as string;
    const calcZip = garageZip || ownerZip;

    const found = fire_zips.find((i: string) => i == calcZip);
  
    if (found) {
      return true;
    } else {
      return false;
    } 
  }



  // used to check before referring to Yacht program
  public checkIfStateIsInStormStates() {
    const isCoastal = this.isCoastal();
    const checkByState = this.getCheckByState();
    // fill this if need to close only if coastal in specific states
    const closeOnlyIfCoastal:State[] = [];
    // return true if state is in storm states or if coastal 
    if (closeOnlyIfCoastal.includes(checkByState)) {
      return isCoastal;
    }
    else {
      return this.stormStates.includes(checkByState);
    }
  }
  
  public setMTALastPremium({ mtaLastPremium }:any) {
    this.MTALastPremium = mtaLastPremium; 
  }

  public getMTALastPremium({ formatted = true }:any)  {
    return formatted ? priceFormat(this.MTALastPremium) : this.MTALastPremium;
  }

  public getproRata({ formatted = true }:any) {
    const proRata = Number(this.getMTAPremium()) - this.getMTALastPremium({ formatted: false });
    return formatted ? priceFormat(proRata.toFixed(0)) : proRata.toFixed(0);
  }

  public setMTAPremium({ Total_Premium_Monthly, Total_Premium_Annual, switchValuesForRenewal = false }:{ Total_Premium_Monthly: number, Total_Premium_Annual: number, switchValuesForRenewal?: boolean }) {
    const { Payment_option, Is_MTA, Is_Renewal } = this.getQuestionsValues(['Payment_option', 'Is_MTA', 'Is_Renewal']);
    const isMta = Is_MTA === '$_BOOL_true';
    const isRenewal = Is_Renewal === '$_BOOL_true';
    if (isRenewal && !isMta) {
      const { Renewal_User_Override_Payment_Option } = this.getQuestionsValues(['Renewal_User_Override_Payment_Option']);
      if (switchValuesForRenewal) { 
        // we alter the values according to the customer selection. The values were saved after calling the rate
        this.MTAPremium = Renewal_User_Override_Payment_Option === 'Monthly' ? this.RenewalMTAPremium.monthly : this.RenewalMTAPremium.annual;
        return;
      } else {
      // save both values to be used later, populated on the first function call after getting the rate response
        this.RenewalMTAPremium.monthly = Total_Premium_Monthly;
        this.RenewalMTAPremium.annual = Total_Premium_Annual;
        // on renewal we need to check if the user has selected a different payment option. 
        // this field is pre populated with the value from the renewal policy
        this.MTAPremium = Renewal_User_Override_Payment_Option === 'Monthly' ? Total_Premium_Monthly : Total_Premium_Annual;
      }
      return;
    } else {
      this.MTAPremium = Payment_option === 'Monthly' ? Total_Premium_Monthly : Total_Premium_Annual;
    }
  }

  getMTAPremium() {
    return this.MTAPremium.toFixed(0);
  }  

  checkIsPaymentOptionMonthly() {
    const { Is_MTA, Is_Renewal } = this.getQuestionsValues(['Payment_option', 'Is_MTA', 'Is_Renewal']);
    const isMta = Is_MTA === '$_BOOL_true';
    const isRenewal = Is_Renewal === '$_BOOL_true';
    if (isRenewal && !isMta) {
      // on renewal we need to check if the user has selected a different payment option. 
      // this field is pre populated with the value from the renewal policy
      const { Renewal_User_Override_Payment_Option } = this.getQuestionsValues(['Renewal_User_Override_Payment_Option']);
      return Renewal_User_Override_Payment_Option === 'Monthly';
    }
    else {
      return this.model.getQuestionById('Payment_option')?.value === 'Monthly';
    }
  }

  async validateStateAndZipCode(data: any): Promise<any> {
    const { zipId, qId, subject } = data;
    //const stateValue = this.model.getQuestionById(stateId)?.value;
    const stateValue = 'All';
    const zipValue = this.model.getQuestionById(zipId)?.value;
    const zipValueAfterTrim = zipValue?.toString().trim();
    let shortZipValue = zipValueAfterTrim;
    if (
      zipValueAfterTrim &&
      zipValueAfterTrim.toString().trim().length > 5 &&
      zipValueAfterTrim.substring(5, 6) == '-'
    ) {
      shortZipValue = zipValueAfterTrim.toString().trim().substring(0, 5);
    }

    const additional_params = qId ? `&qId=${qId}&subject=${subject}` : '';
    const url = `/address/validate-zip-code-by-state?stateCode=${stateValue}&zipCode=${shortZipValue}${additional_params}`;
    const response = (await this.deps.apiService.http<any>(url)).data;
    return response;
  }

  checkOverrideZipQuestion(qId: string) {
    const errorText = qId + '_zip_state_error';
    if (!this.overrideUWrule(errorText)) {
      const lastErrorQuestion = this.model.getQuestionById('last_error');
      if (lastErrorQuestion) lastErrorQuestion.value = errorText;
      return true;
    } else return false;
  }

  public async validateAutocompleteAddress(block: number = -1): Promise<any> {
    const ownerZipVerified = this.model.getQuestionById('Owner_Zip_Valid')?.value === '$_BOOL_true';
    //const ownerZipHashMatch = this.model.getQuestionById("Owner_Zip_Hash")?.value === this.model.getQuestionById('state')?.value + '|' + this.model.getQuestionById('owner_zip_code')?.value;
    const ownerZipHashMatch =
      this.model.getQuestionById('Owner_Zip_Hash')?.value ===
      'All|' + this.model.getQuestionById('owner_zip_code')?.value;
    const garageZipVerified = this.model.getQuestionById('Garage_Zip_Valid')?.value === '$_BOOL_true';
    //const garageZipHashMatch = this.model.getQuestionById("Garage_Zip_Hash")?.value === this.model.getQuestionById('garage_state')?.value + '|' + this.model.getQuestionById('garage_zip_code')?.value;
    const garageZipHashMatch =
      this.model.getQuestionById('Garage_Zip_Hash')?.value ===
      'All|' + this.model.getQuestionById('garage_zip_code')?.value;
    const is_garage = this.model.getQuestionById('is_garaged')?.value === '$_BOOL_true';

    const ownerZipOverrideCondition = this.checkOverrideZipQuestion('owner');
    const garageZipOverrideCondition = this.checkOverrideZipQuestion('garage');

    /**first time use status from Zoho, after changes use last check status*/
    const ownerReturnTrueCondition =
      ownerZipOverrideCondition ||
      (!this.ownerAddressAutocompleteUpdated &&
        ((ownerZipVerified && ownerZipHashMatch && !this.ownerAddressAutocompleteChecked) ||
          (this.ownerAddressAutocompleteValid && this.ownerAddressAutocompleteChecked)));
    const garageReturnTrueCondition =
      garageZipOverrideCondition ||
      !is_garage ||
      (!this.garageAddressAutocompleteUpdated &&
        ((garageZipVerified && garageZipHashMatch && !this.garageAddressAutocompleteChecked) ||
          (this.garageAddressAutocompleteValid && this.garageAddressAutocompleteChecked)));

    /** Owner */
    if (!ownerReturnTrueCondition && block != 1) {
      try {
        this.deps.apiService.lock();
        await this.flushPatchQueue();
        const resOwner = await this.validateStateAndZipCode({
          stateId: 'state',
          zipId: 'owner_zip_code',
          qId: this.model.getQuestionnaireId(),
          subject: 'owner',
        });
        if (!resOwner.isValid && resOwner.errorCode === 1) {
          eventBus().emit(Events.Type.AddQuestionError, { qId: 'owner_zip_code', error: 'Unable to verify the zipcode' });
          this.deps.apiService.unlock();
          return false;
        }
        if (!resOwner.isValid && resOwner.errorCode === 2) {
          eventBus().emit(Events.Type.AddQuestionError, {
            qId: 'owner_zip_code',
            error: 'The zipcode provided doesn’t match the State',
          });
          this.deps.apiService.unlock();
          return false;
        }
        if (resOwner.isValid) {
          this.model.getQuestionById('Owner_Zip_Valid')!.value = '$_BOOL_true';
          this.ownerAddressAutocompleteValid = true;
          this.ownerAddressAutocompleteChecked = true;
          this.ownerAddressAutocompleteUpdated = false;
          this.ownerZipIsCoastal = resOwner.isCoastal;
          this.ownerZipIsCoastalChecked = true;
          const deviceType = this.model.getQuestionById('device_type')?.value as string;
          if (deviceType.toLowerCase() === 'mobile') {
            this.deps.apiService.unlock();
            return true;
          }
        }
      } catch (err) {
        this.deps.apiService.unlock();
        const data: WebSectionTrackingData = {
          section: 'S_Address',
          next_section: '',
          operation: 'owner-zip-validation-error',
          errorMessage: JSON.stringify(err, null, ' '),
        };
        eventBus().emit(Events.Type.SaveWebSectionTracking, data);
        this.model.getQuestionById('Owner_Zip_Valid')!.value = '$_BOOL_false';
        this.deps.apiService.unlock();
        return false;
      } finally {
        this.deps.apiService.unlock();
      }
    }
    /** Garage */
    if (!garageReturnTrueCondition && block != 0) {
      try {
        this.deps.apiService.lock();
        await this.flushPatchQueue();
        const resGarage = await this.validateStateAndZipCode({
          stateId: 'garage_state',
          zipId: 'garage_zip_code',
          qId: this.model.getQuestionnaireId(),
          subject: 'garage',
        });
        if (!resGarage.isValid && resGarage.errorCode === 1) {
          eventBus().emit(Events.Type.AddQuestionError, {
            qId: 'garage_zip_code',
            error: 'Unable to verify the zipcode',
          });
          this.deps.apiService.unlock();
          return false;
        }
        if (!resGarage.isValid && resGarage.errorCode === 2) {
          eventBus().emit(Events.Type.AddQuestionError, {
            qId: 'garage_zip_code',
            error: 'The zipcode provided doesn’t match the State',
          });
          this.deps.apiService.unlock();
          return false;
        }
        if (resGarage.isValid) {
          this.model.getQuestionById('Garage_Zip_Valid')!.value = '$_BOOL_true';
          this.garageAddressAutocompleteValid = true;
          this.garageAddressAutocompleteChecked = true;
          this.garageAddressAutocompleteUpdated = false;
          this.garageZipIsCoastal = resGarage.isCoastal;
          this.garageZipIsCoastalChecked = true;
        }
      } catch (err) {
        const data: WebSectionTrackingData = {
          section: 'S_Address',
          next_section: '',
          operation: 'garage-zip-validation-error',
          errorMessage: JSON.stringify(err, null, ' '),
        };
        eventBus().emit(Events.Type.SaveWebSectionTracking, data);
        this.model.getQuestionById('Garage_Zip_Valid')!.value = '$_BOOL_false';
        this.deps.apiService.unlock();
        return false;
      } finally {
        this.deps.apiService.unlock();
      }
    }
    return true;
  }

  public async validateDriver(): Promise<{msg: string; value: boolean; errorType: string}> {
    
    const verified = this.model.getQuestionById('driving_license_status')!.value === 'Verified';    

    if (typeof this.violationError === 'undefined') {
      const Minor_violations_count = this.model.getQuestionById('driving_license_minor_violations')?.value as number;
      const Major_violations_count = this.model.getQuestionById('driving_license_major_violations')?.value as number;
      const At_fault_accident_count = this.model.getQuestionById('driving_license_fault_accidents')?.value as number;

      this.violationError = this.checkDriverViolations(
        Minor_violations_count,
        Major_violations_count,
        At_fault_accident_count,
      );
    }

    //first time use driving_license_status from Zoho
    //after changes use last check status
    //dont validate dirver license in MTA if not changed
    // on MTA even if there is violation error don't check again, unless the user changed one of the driver details
    if ((this.isMta() && !this.updated) || (!this.updated && !this.violationError && (((verified || this.isMta()) && !this.validDriverChecked) || (this.validDriver && this.validDriverChecked)))) {
      return { value: true, msg: '', errorType: '' };
    } else {
      this.deps.apiService.lock();
      await this.flushPatchQueue();
      let result;
      try {
        result = (await this.deps.apiService.http('/driver/validate-driver', { post: 'post' })).data;
      } catch (err) {
        const data: WebSectionTrackingData = {
          section: 'S_Driver',
          next_section: '',
          operation: 'Driver-technical-error',
          errorMessage: JSON.stringify(err, null, ' '),
        };

        eventBus().emit(Events.Type.SaveWebSectionTracking, data);
        return { value: false, msg: t('E_Samba', this.model.getSupportPhoneNumberText()), errorType: 'Driver-Error' };
      } finally {
        this.deps.apiService.unlock();
      }
      this.validDriverChecked = true;
      this.updated = false;
      if (result.data.valid) {
        this.validDriver = true;

        //checking UW violations error popup
        const { Minor_violations_count, Major_violations_count, At_fault_accident_count } = result.data;

        if (
          this.checkDriverViolations(Minor_violations_count, Major_violations_count, At_fault_accident_count) &&
          this.overrideUWrule('UW_Error_21D')
        ) {
          this.violationError = true;
          return {
            value: false,
            msg: t('UW_Error_21D', this.model.getSupportPhoneNumberText()),
            errorType: 'UW_Error_21D',
          };
        } else {
          this.violationError = false;
          return { value: true, msg: '', errorType: '' };
        }
      } else {
        this.validDriver = false;
        const data: WebSectionTrackingData = {
          section: 'S_Driver',
          next_section: '',
          operation: 'Driver-error',
          errorMessage: result.data.error,
        };
        eventBus().emit(Events.Type.SaveWebSectionTracking, data);

        const errorMsg = this.generateSambaErrorMsg(result.data?.error || '');
        if (result.data?.error && result.data?.error != 'ORDER DOES NOT MEET STATE ORDERING REQUIREMENTS') {
          return { value: false, msg: errorMsg, errorType: 'Driver-Error' };
        } else {
          return { value: false, msg: errorMsg, errorType: 'UW_Error_23' };
        }
      }
    }
  }

  private checkDriverViolations(
    Minor_violations_count: number = 0,
    Major_violations_count: number = 0,
    At_fault_accident_count: number = 0,
  ): boolean {
    return Major_violations_count >= 1 || At_fault_accident_count >= 2 || Minor_violations_count >= 3;
  }

  // Asks the backend to recompute the contact's claims summary. The backend reads the
  // claims from Zoho (3-year window ending at Effective_Date), persists Number_of_Claims /
  // Last_Claim_Date to the questionnaire, and returns them so we can mirror them into local
  // question state. Non-blocking: errors are logged and swallowed so navigation isn't interrupted.
  // DISABLED with the past-boat trigger — kept for reference.
  // True when `section` comes strictly before `currentSection` in the funnel order,
  // i.e. the user has moved past `section`.
  // private isPastSection(section: string, currentSection: string): boolean {
  //   const sections = this.model.getSections().map((s) => s.sectionId);
  //   const sectionIdx = sections.indexOf(section);
  //   const currentIdx = sections.indexOf(currentSection);
  //   return sectionIdx !== -1 && currentIdx !== -1 && currentIdx > sectionIdx;
  // }

  public async fetchClaimsSummary(): Promise<void> {
    this.deps.apiService.lock();
    try {
      await this.flushPatchQueue();
      const resp = await this.deps.apiService.http('/claims/refresh-summary', { post: 'post' });
      const data = resp?.data;
      if (!data || data.skipped) return;
      const claimsCountQuestion = this.model.getQuestionById('Number_of_Claims');
      const lastClaimDateQuestion = this.model.getQuestionById('Last_Claim_Date');
      if (claimsCountQuestion) claimsCountQuestion.value = data.Number_of_Claims;
      if (lastClaimDateQuestion) lastClaimDateQuestion.value = data.Last_Claim_Date;
    } catch (err) {
      console.error('fetchClaimsSummary error:', err);
    } finally {
      this.deps.apiService.unlock();
    }
  }

  private generateSambaErrorMsg(error_message: string) {
    const sambaError = error_message.toLowerCase() || '';
    const supportNumber= '1-855-289-2469';
    let sambaErrorEdited = '';
    let sambaErorrType = 'E_Samba';
    //This part parses creates a user readable error message according to the returned error
    if (sambaError && (sambaError.includes('document error: document number, state, last name fuzzy, date of birth.')) ||
                 sambaError.includes('order does not meet state ordering requirements') ||
                 sambaError.includes('driver not found') ||
                 sambaError.includes('no results') ||
                 sambaError.includes('license and name or dob do not match') 
    ){

      sambaErorrType = 'E_Samba_General';

    } 
    else if
    (sambaError && sambaError.includes('document error: last name fuzzy, date of birth.')) {
      
      sambaErorrType = 'E_Samba_Name_DOB';

    }  
    else if
    (sambaError && sambaError.includes('document error: document number.')) {

      sambaErorrType = 'E_Samba_DOCUMENT_NUMBER';

    }  
    else if
    (sambaError && sambaError.includes('document error: date of birth.')) {

      sambaErorrType = 'E_Samba_DOB';

    }  
    else if
    (sambaError && sambaError.includes('document error: last name fuzzy.')) {

      sambaErorrType = 'E_Samba_NAME';

    }
    // This part is the original treatemnt and will be performed for errors different from the above
    else {   
      if (sambaError && sambaError.includes('document error')) {
        /** Text changes  */
        let sambaErrorDraft = `
        ${t('Please verify your: ')}
        ${sambaError.includes('document number') ? t("Driver's License Number, ") : ''}
        ${sambaError.includes('last name fuzzy') ? t('Last Name, ') : ''}
        ${sambaError.includes('first name fuzzy') ? t('First Name, ') : ''}
        ${sambaError.includes('state') ? t('State, ') : ''}
        ${sambaError.includes('date of birth') ? t('Date of Birth, ') : ''}
        `;

        /** Replacing the last comma with a dot */
        if (sambaErrorDraft && sambaErrorDraft.lastIndexOf(',') > 0) {
          sambaErrorDraft = sambaErrorDraft.replace(/,([^,]*)$/, '.$1');
        }

        sambaErrorEdited = sambaErrorDraft || '';
      }
    }
    let msg='';
    if (sambaErorrType=='E_Samba'){
      msg = `${t(sambaErorrType, supportNumber)} ${t(sambaErrorEdited)}`;
    }
    else {
      msg = `${t(sambaErorrType, supportNumber)}`;
    }  
    return msg;
  }

  getNameTitle(): string {
    const name = (this.model.getQuestionById('owner_name')?.value as String) || '';
    return name ? name.split(' ')[0] : '';
  }

  private discountPercentString(discountPercent: number = 0.05): string {
    return `${discountPercent * 100}%`;
  }

  getToastIcon() {
    let response;
    response = WelcomeToastIcon;
    const logoUrl = this.affiliateService?.getLogoUrl({});
    if (logoUrl) {
      response = `<img id="logo" alt="Ahoy! Logo" src="${logoUrl?.desktop}" />`;
    }
    return response;
  }

  async welcomePopup(fromLoginView = false) {
    const username = this.getNameTitle();
    const watercraftName = this.model.getBoatDisplayName();

    let toastData: ToastData = {};
    if (this.model.getStatus() === 'Mem' && fromLoginView) {
      // here we displayed msg, decided to remove it
      // let popupName = 'welcome-login-no-user-popup';
      // const next = this.model.isNew() ? 'T_Forward' : 'T_Continue';
      // await this.deps.popupService.showPopup(popupName, '', next, popupName);
    } else if (this.model.getQuestionById('promotion_code')?.value) {
      /** welcome-login-no-user-popup */
      toastData = {
        text: t('T_Promotion_Toast_Text', this.discountPercentString()),
        icon: PromotionToastIcon,
      };
    } else if (this.model.isNew()) {
      /** welcome-new-user-popup */

      defer('src').then(async() => {
        const username = this.getNameTitle();
        const watercraftName = this.model.getBoatDisplayName();

        const icon = unsafeHTML(`${this.getToastIcon()}`);
        toastData = {
          text: t('T_Welcome_New_User_Toast_Text', watercraftName),
          headerText: t('T_Welcome_New_User_Toast_Title', username),
          icon,
        };
        this.showToast(toastData);
      });
    } else if (this.model.getStatus() != 'Mem') {
      defer('src').then(async(affiliate) => {
        const affiliateFromQuestion = this.model?.getQuestionById('Affiliate')?.value as string;
        if (affiliateFromQuestion) affiliate = affiliateFromQuestion;
        const affiliateCondition = this.isAffiliateExist(affiliate);
        if (affiliateCondition) {
          const icon = unsafeHTML(`${this.getToastIcon()}`);
          toastData = {
            text: t('T_Existing_User_Toast_Text_Affiliate', watercraftName),
            icon,
          };
        } else {
          /**welcome-existing-user-popup*/
          const firstLineText = username
            ? t('T_Existing_User_Toast_Text', username)
            : t('T_Existing_User_Toast_Text_Backup');
          const secondLinetext = t('T_Existing_User_Toast_Text_2');
          toastData = {
            text: firstLineText + secondLinetext,
            icon: WelcomeToastIcon,
          };
        }
        if (toastData?.text) {
          this.showToast(toastData);
        }
      });
      if (toastData?.text) {
        this.showToast(toastData);
      }
    }

    eventBus().emit(Events.Type.Refresh, this.model.getStatus());
  }

  async completePopup() {
    await this.deps.popupService.showPopup('complete-questionaire-popup', '', 'T_Forward_Thanks');
  }

  changeToMemoryMode() {
    this.memoryMode = true;
    this.model.changeToMemoryMode();
  }

  saveMemoryMode() {
    this.memoryMode = false;
    this.model.saveMemoryMode();
  }

  cancelMemoryMode() {
    this.model.cancelMemoryMode();
    this.memoryMode = false;
  }

  private updateQuestionsInModel(items: Record<string, any>) {    
    try {
      Object.entries(items).forEach((entry) => {
        const [qId, newValue] = entry;
        const question = this.model.getQuestionById(qId);
        if (!question) return;
        if (typeof newValue !== 'undefined') {
          question.value = newValue?.toString();
        }
      });
    } catch {
      return;
    }
  }

  public updateTotalPremiumAndInstallmentsDetails(items: insurance_package) {
    const model = this.model;
    // adding update of zoho Total_Premium_Annual, Down_Payment_Amount, Installment_Amount fields,
    // which appear on the email sent to the customer. These values need to be updated on package change
    const premium:Premium = {
      'annual-amount': items.TotalPremiumAnnualy,
      'monthly-amount': items.TotalPremiumMonthly,
    };
    const { installments:Installments_Number, installment:Installment_Amount, downPayment:Down_Payment_Amount } = model.getDownpaymentInstallmentAndTotalAmounts({ premium });
    const payedMonthly = model.getQuestionById('Payment_option')?.value == 'Monthly';

    const amounts = {
      Total_Premium: payedMonthly ? items.TotalPremiumMonthly : items.TotalPremiumAnnualy,
      Total_Premium_Annual: items.TotalPremiumAnnualy,
      Total_Premium_Monthly: items.TotalPremiumMonthly,
      Installment_Amount, 
      Installments_Number,
      Down_Payment_Amount,
    };

    this.updateQuestionsInModel(amounts);
  }

  populate(items: insurance_package) {
    // this function is used to remove fields from the update to Zoho if needed     
    const editFieldValuesByState = ({ items }:any) => {
      const calculatedStateQuestion:any = model.getQuestionById('Calculated_State');
      const isPreventUpdateStateVA = !['VA'].includes(calculatedStateQuestion?.value);
      const isPreventUpdateStateMN = !['MN'].includes(calculatedStateQuestion?.value);
      if (isPreventUpdateStateVA) {
        items['UBUIBPD_Limit'] = '';
        items['UBUIBPD_Limit_YN'] = '$_BOOL_false';
      }
      if (isPreventUpdateStateMN) {
        items['Family_Bodily_Injury_YN'] = '$_BOOL_false';
      }
      return items;
    };
    if (!items) return;
    const model = this.model;
    // this is where the premium amounts are set. we do it separately because we need to calcaulate 
    // some values first. they're not updated again later because their keys in the itmes object aren't
    // valid questionIds. this is the only place where we set the premium values
    this.updateTotalPremiumAndInstallmentsDetails(items);
    items = editFieldValuesByState({ items });
    this.updateQuestionsInModel(items);
    this.model.joinField('UBUBBI_Limit_per_person', 'UBUBBI_Limit_per_occurrence', 'UBUBBI_Limit');
    this.model.joinField('BI_Limit_per_person', 'BI_Limit_per_occurrence', 'BI_Limit');
  }

  setTotalPremium(totalPremium: Premium) {
    this.TotalPremium = totalPremium;
  }

  setTotalPremiumByPackage(items: insurance_package) {
    this.TotalPremium['annual-amount'] = items.TotalPremiumAnnualy;
    this.TotalPremium['monthly-amount'] = items.TotalPremiumMonthly;
  }

  getTotalPremium(): Premium {
    return this.TotalPremium;
  }

  getPayLessOnAnnualText({
    item = {} as insurance_package,
    isPremium = false,
    premiumData = {} as Premium,
    isDataForTopHeader = false,
    dataForTopHeader = {} as packageData | undefined,
  }: getPayLessOnAnnualTextData): TemplateResult<1> {
    if (isDataForTopHeader) {
      return html`${t('T_Pay_In_Full', dataForTopHeader?.annualyPrice)}`;
    }
    if (isPremium) {
      return html`${t('T_Pay_In_Full', priceFormat(premiumData['annual-amount']))} `;
    }
    const amount: any = item?.TotalPremiumAnnualy;
    if (!amount) return html``;
    const payLessOnAnnualText = amount ? html`${t('T_Pay_In_Full', priceFormat(amount))} ` : html``;
    return payLessOnAnnualText;
  }

  public handleResetOcrInput() {
    this.model.getQuestionById('Boat_Ocr_Overriden_Qids')!.value = '';
    const ocrDataQuestion = this.model.getQuestionById('ocr_boat_data');
    if (ocrDataQuestion) ocrDataQuestion.value = '';
  }

  public logLogout(logoutOrigin: LogoutOrigin) {
    /** Preparing tracking data */
    const currentSection = this.model.getActiveSectionName() || '';
    const data: WebSectionTrackingData = {
      section: currentSection,
      next_section: logoutOrigin || '',
      operation: 'logout',
      errorMessage: '',
    };

    /** Logging data */
    eventBus().emit(Events.Type.SaveWebSectionTracking, data);
  }

  public logWindowClosed() {
    /** Preparing tracking data */
    const currentSection = this.model.getActiveSectionName() || '';
    const data: WebSectionTrackingData = {
      section: currentSection,
      next_section: '',
      operation: 'window-closed',
      errorMessage: '',
    };

    /** Logging data */
    eventBus().emit(Events.Type.SaveWebSectionTracking, data);
  }

  public logExitPopupClosed() {
    /** Preparing tracking data */
    const currentSection = this.model.getActiveSectionName() || '';
    const data: WebSectionTrackingData = {
      section: currentSection,
      next_section: '',
      operation: 'exit-popup-closed',
      errorMessage: '',
    };

    /** Logging data */
    eventBus().emit(Events.Type.SaveWebSectionTracking, data);
  }

  private logExitPopupOpened() {
    /** Preparing tracking data */
    const currentSection = this.model.getActiveSectionName() || '';
    const data: WebSectionTrackingData = {
      section: currentSection,
      next_section: '',
      operation: 'exit-popup-opened',
      errorMessage: '',
    };

    /** Logging data */
    eventBus().emit(Events.Type.SaveWebSectionTracking, data);
  }

  /** Show Popup message each time the user tries to leave our site/exit the funnel */
  private showExitPopup(popupData: PopupData) {
    /** Logging data */
    this.logExitPopupOpened();

    /** Show popup */
    const { popupName, message, buttonText, popupClassName } = popupData;
    this.showPopupOnEvent(popupName, message, buttonText, popupClassName);
  }

  getQuestionsValues(questionIds: string[]): Record<string, string | number | any> {
    return this.model.getQuestionsValues(questionIds);
  }

  private getErrorCodeTextFromMap(popupComponentName: string | undefined): string | undefined {
    const filteredItem = errorCodesMap?.find((el) => popupComponentName === el.popupComponentName);
    return filteredItem?.errorCodeText || undefined;
  }

  async returnBackToCustomerTask(popupComponentName?: string,showConfiramtionMsgInPopup = true) {
    this.deps.apiService.lock();
    let errorCode;

    const lastError = this.model.getQuestionById('last_error')?.value;
    const errorCodeTextFromMap: string | undefined = this.getErrorCodeTextFromMap(popupComponentName);
    errorCode = errorCodeTextFromMap || lastError || popupComponentName;

    const response = await this.deps?.apiService.http('/agent/return-back-to-customer-task', {
      errorCode,
      reasonCode: 'Error',
    });
    if (showConfiramtionMsgInPopup) eventBus().emit(Events.Type.ReturnBackToCustomerTaskResponse, { response, popupComponentName });
    this.deps.apiService.unlock();
  }

  public async checkDirectIndirect():Promise<CheckDirectIndirectResponse> {
    try {
      this.deps.apiService.lock();
      const response:CheckDirectIndirectResponse = (await this.deps?.apiService.http('/agent/check-direct-indirect', {}))?.data;
      return response || { 'Status': 'Error', 'Error': 'No message returned', 'Type': '', 'Send To': '' };
    } catch (err:any) {
      return { 'Status': 'Error', 'Error': err?.message || '', 'Type': '', 'Send To': '' };
    } finally {
      this.deps.apiService.unlock();
    }
  }

  private async isDirectOrIndirectUser() {
    const checkDirectIndirectResponse = await this.checkDirectIndirect();
    const isDirect = checkDirectIndirectResponse?.Type === 'Direct';
    return isDirect;
  }

  async createLead(name: string, email: string) {
    await this.deps?.apiService.http('/agent/create-lead', { name, email });
  }

  async addNewBoat() {
    this.deps.apiService.lock();
    this.mainQuestionnaireId = this.questionnaireId;
    const newBoat = await this.deps.apiService.http('/add-boat', { questionnaireId: this.questionnaireId });
    // this.syncFromServer(newBoat);
    this.deps.apiService.unlock();
    return newBoat.data.questionnaire;
  }

  public isNumber(item: any) {
    return !isNaN(item);
  }
  public isBoolean(item: any) {
    return typeof item === 'boolean';
  }
  public isString(item: any) {
    return typeof item === 'string' || item instanceof String;
  }
  public isObject(item: any) {
    return typeof item === 'object' && !Array.isArray(item) && item !== null;
  }

  public generateInsuracePackageFromPackageData(packageData: PackageData): insurance_package | undefined {
    let insurancePackageEntries: any = {};
    const packageDataEntries = Object.entries(packageData);
    packageDataEntries?.map((entry) => {
      const [prop, val] = entry;
      let insurancePackageProp = insuracePackageFromPackageData[prop];
      if (this.isString(insurancePackageProp)) {
        insurancePackageEntries[insurancePackageProp.toString()] = val;
      } else {
        if (this.isObject(insurancePackageProp)) {
          Object.entries(insurancePackageProp)?.map((entry) => {
            const [prop, innerval] = entry;
            if (prop && this.isString(innerval)) {
              //@ts-ignore
              insurancePackageEntries[innerval] = val[prop];
            }
          });
        }
      }
    });
    return insurancePackageEntries;
  }

  public zohoStrToBoolean(str: string): boolean | undefined {
    if (!['$_BOOL_true', '$_BOOL_false'].includes(str)) return;
    let response;
    if (str === '$_BOOL_true') response = true;
    if (str === '$_BOOL_false') response = false;
    return response;
  }

  public booleanToZohoStr(str: boolean): string | undefined {
    if (!this.isBoolean(str)) return;
    let response;
    if (str === true) response = '$_BOOL_true';
    if (str === false) response = '$_BOOL_false';
    return response;
  }

  public changeObjBooleanValuesToMatchZoho(obj: any) {
    if (!obj) return;
    let responseArr: any[] = [];
    const entries = Object.entries(obj);
    entries?.map((el) => {
      const [prop, val] = el;
      if (this.isBoolean(val)) {
        let editedVal:any = val;
        editedVal = val ? '$_BOOL_true' : '$_BOOL_false';
        responseArr.push([prop, editedVal as string]);
      } else {
        responseArr.push([prop, val]);
      }
    });
    const response = Object.fromEntries(responseArr);
    return response;
  }

  getLastCharAsNumber(str: string) {
    const responseStr = str?.charAt(str.length - 1);
    const responseNum = responseStr ? +responseStr : 1;
    return responseNum;
  }
}

QuestionsService.define();